import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    ku: {
        translation: {
            "onlineAccounting": {
                "title": "ژمێریاری ئۆنلاین",
                "students": "قوتابیانی ئۆنلاین",
                "expenses": "خەرجیەکانی ئۆنلاین",
                "income": "داهاتی ئۆنلاین",
                "reports": "ڕاپۆرتەکانی ئۆنلاین",

                // Students
                "addStudent": "زیادکردنی قوتابیی ئۆنلاین",
                "editStudent": "دەستکاریکردنی قوتابیی ئۆنلاین",
                "studentCreated": "قوتابی بە سەرکەوتوویی دروستکرا",
                "studentUpdated": "قوتابی بە سەرکەوتوویی نوێکرایەوە",
                "studentDeleted": "قوتابی بە سەرکەوتوویی سڕایەوە",
                "confirmDeleteStudent": "دڵنیایت لە سڕینەوەی ئەم قوتابیە؟",
                "totalStudents": "کۆی قوتابیان",
                "activeStudents": "قوتابیە چالاکەکان",
                "searchStudent": "گەڕان بەدوای قوتابیدا...",
                "filterByStatus": "فلتەرکردن بەپێی دۆخ",
                "studentId": "ژمارەی قوتابی",
                "name": "ناو",
                "firstName": "ناوی یەکەم",
                "lastName": "ناوی دووەم",
                "email": "ئیمەیڵ",
                "phone": "ژمارەی تەلەفۆن",
                "dateOfBirth": "ڕێکەوتی لەدایکبوون",
                "gender": "ڕەگەز",
                "male": "نێر",
                "female": "مێ",
                "other": "ئەوانی تر",
                "course": "کۆرس",
                "courseName": "ناوی کۆرس",
                "totalFees": "کۆی کرێ",
                "paidAmount": "بڕی پارەدراو",
                "remaining": "ماوە",
                "paymentStatus": "دۆخی پارەدان",
                "paid": "پارەدراو",
                "partial": "بەشێک",
                "unpaid": "پارەنەدراو",
                "active": "چالاک",
                "inactive": "ناچالاک",
                "suspended": "ڕاگیراو",
                "graduated": "دەرچوو",
                "notes": "تێبینیەکان",

                // Expenses
                "addExpense": "زیادکردنی خەرجیی ئۆنلاین",
                "editExpense": "دەستکاریکردنی خەرجیی ئۆنلاین",
                "expenseCreated": "خەرجی بە سەرکەوتوویی دروستکرا",
                "expenseUpdated": "خەرجی بە سەرکەوتوویی نوێکرایەوە",
                "expenseDeleted": "خەرجی بە سەرکەوتوویی سڕایەوە",
                "confirmDeleteExpense": "دڵنیایت لە سڕینەوەی ئەم خەرجیە؟",
                "totalExpenses": "کۆی خەرجیەکان",
                "searchExpense": "گەڕان بەدوای خەرجیدا...",
                "filterByCategory": "فلتەرکردن بەپێی جۆر",
                "expenseNumber": "ژمارەی خەرجی",
                "date": "ڕێکەوت",
                "category": "جۆر",
                "description": "وردەکاری",
                "vendor": "دابینکەر",
                "vendorName": "ناوی دابینکەر",
                "vendorContact": "پەیوەندیکردن بە دابینکەر",
                "amount": "بڕ",
                "paymentMethod": "شێوازی پارەدان",
                "hosting": "هۆستینگ",
                "domain": "دۆمەین",
                "software": "نەرمەکاڵا",
                "marketing": "بازرگانی",
                "advertising": "ڕێکلام",
                "payment-gateway": "دەروازەی پارەدان",
                "support-tools": "ئامرازەکانی پشتیوانی",
                "design": "دیزاین",
                "development": "گەشەپێدان",
                "maintenance": "چاککردنەوە",
                "other": "ئەوانی تر",
                "cash": "کاش",
                "bank-transfer": "گواستنەوەی بانکی",
                "card": "کارت",
                "online": "ئۆنلاین",
                "paypal": "پەیپاڵ",
                "stripe": "ستڕایپ",
                "pending": "چاوەڕوان",
                "cancelled": "هەڵوەشاوە",

                // Income
                "incomeNumber": "ژمارەی داهات",
                "studentName": "ناوی قوتابی",
                "totalPayments": "کۆی پارەدانەکان",
                "searchIncome": "گەڕان بەدوای داهاتدا...",
                "paymentType": "جۆری پارەدان",
                "enrollment": "تۆمارکردن",
                "monthly": "مانگانە",
                "installment": "بەشەکان",
                "full-payment": "پارەی تەواو",
                "transactionId": "ژمارەی مامەڵە",
                "completed": "تەواو",
                "failed": "سەرکەوتوو نەبوو",
                "refunded": "گەڕایەوە",

                // Reports
                "totalIncomeUSD": "کۆی داهات (دۆلار)",
                "totalExpenseUSD": "کۆی خەرجی (دۆلار)",
                "totalIncomeIQD": "کۆی داهات (دینار)",
                "totalExpenseIQD": "کۆی خەرجی (دینار)",
                "profitUSD": "قازانج (دۆلار)",
                "profitIQD": "قازانج (دینار)",
                "studentPaymentStatus": "دۆخی پارەدانی قوتابیان",
                "monthlyIncome": "داهاتی مانگانە",
                "expensesByCategory": "خەرجیەکان بەپێی جۆر",
                "totalUSD": "کۆ (دۆلار)",
                "totalIQD": "کۆ (دینار)",

                // Common
                "currency": "دراو",
                "status": "دۆخ",
                "error": "هەڵەیەک ڕوویدا",
                "confirmDelete": "دڵنیاکردنەوەی سڕینەوە",
                "count": "ژمارە",
                "month": "مانگ",
                "actions": "کردارەکان",
                "view": "بینین",
                "studentNotFound": "قوتابی نەدۆزرایەوە",
                "paymentAdded": "پارەدان بە سەرکەوتوویی زیادکرا",
                "amountExceedsRemaining": "بڕەکە زۆرترە لە بڕی ماوە",
                "editIncome": "دەستکاریکردنی داهاتی ئۆنلاین",
                "addIncome": "زیادکردنی داهاتی ئۆنلاین",
                "student": "قوتابی",
                "enterNotes": "تێبینی بنووسە",
                "create": "دروستکردن",
                "update": "نوێکردنەوە",
                "cancel": "هەڵوەشاندنەوە",
                "undefined": "نەدیارکراو",
                "paymentDetails": "وردەکاری پارەدان",
            },
            // Navigation
            "dashboard": "داشبۆرد",
            "academies": "ئەکادیمیەکان",
            "academic": "ئەکادیمی",
            "students": "قوتابیان",
            "staff": "کارمەندان",
            "courses": "کۆرسەکان",
            "finance": "دارایی",
            "income": "داهات",
            "expenses": "خەرجی",
            "recurringExpenses": "خەرجییە دووبارەکان",
            "certificates": "بڕوانامەکان",
            "invoices": "پسولەەکان",
            "reports": "ڕاپۆرتەکان",
            "users": "بەکارهێنەران",
            "institute": "پەیمانگە",

            // Recurring Expenses
            "addRecurringExpense": "زیادکردنی خەرجی دووبارە",
            "editRecurringExpense": "دەستکاریکردنی خەرجی دووبارە",
            "recurringExpenseAdded": "خەرجی دووبارە زیادکرا",
            "recurringExpenseUpdated": "خەرجی دووبارە نوێکرایەوە",
            "recurringExpenseDeleted": "خەرجی دووبارە سڕایەوە",
            "failedToAddRecurringExpense": "زیادکردنی خەرجی دووبارە سەرکەوتوو نەبوو",
            "failedToUpdateRecurringExpense": "نوێکردنەوەی خەرجی دووبارە سەرکەوتوو نەبوو",
            "failedToDeleteRecurringExpense": "سڕینەوەی خەرجی دووبارە سەرکەوتوو نەبوو",
            "confirmDeleteRecurringExpense": "دڵنیایت لە سڕینەوەی ئەم خەرجی دووبارەیە؟",
            "expenseName": "ناوی خەرجی",
            "pleaseEnterExpenseName": "تکایە ناوی خەرجی بنووسە",
            "expenseNamePlaceholder": "وەک: کرێی پەیمانگە، کارەبا، ئاو",
            "expenseType": "جۆری خەرجی",
            "pleaseSelectExpenseType": "تکایە جۆری خەرجی هەڵبژێرە",
            "selectExpenseType": "جۆری خەرجی هەڵبژێرە",
            "descriptionPlaceholder": "وردەکاری زیاتر...",
            "frequency": "دووبارەبوونەوە",
            "monthly": "مانگانە",
            "quarterly": "سێ مانگ جارێک",
            "yearly": "ساڵانە",
            "dayOfMonth": "ڕۆژی مانگ",
            "startDate": "ڕێکەوتی دەستپێکردن",
            "lastGenerated": "دواین جاری دروستکراو",
            "generateMonthlyExpenses": "دروستکردنی خەرجیەکانی مانگانە",
            "monthlyExpensesGenerated": "خەرجیەکانی مانگانە دروستکران",
            "failedToGenerateExpenses": "دروستکردنی خەرجیەکان سەرکەوتوو نەبوو",
            "generateExpensesDescription": "ئەم کردارە خەرجیەکانی دووبارە و مووچەی کارمەندان بۆ مانگی هەڵبژێردراو دەخاتە ناو سیستەم",
            "month": "مانگ",
            "year": "ساڵ",
            "generate": "دروستکردن",
            "howItWorks": "چۆن کاردەکات؟",
            "recurringExpensesDescription": "خەرجیە دووبارەکان وەک کرێ و کارەبا بە شێوەیەکی خۆکار هەموو مانگێک دروستدەکرێن. مووچەی کارمەندە چالاکەکانیش خۆکار زیاددەکرێت.",

            // Month Names
            "january": "کانوونی دووەم",
            "february": "شوبات",
            "march": "ئازار",
            "april": "نیسان",
            "may": "ئایار",
            "june": "حوزەیران",
            "july": "تەمووز",
            "august": "ئاب",
            "september": "ئەیلوول",
            "october": "تشرینی یەکەم",
            "november": "تشرینی دووەم",
            "december": "کانوونی یەکەم",

            // Common
            "add": "زیادکردن",
            "edit": "دەستکاریکردن",
            "delete": "سڕینەوە",
            "save": "پاشەکەوتکردن",
            "cancel": "پاشگەزبوونەوە",
            "login": "چوونەژوورەوە",
            "logout": "چوونەدەرەوە",
            "paymanga": "پەیمانگا",
            "languageInstituteManagementSystem": "سیستەمی بەڕێوەبردنی پەیمانگەی زمان",
            "email": "ئیمەیڵ",
            "password": "وشەی نهێنی",
            "pleaseInputEmail": "تکایە ئیمەیڵەکەت بنووسە",
            "pleaseInputPassword": "تکایە وشەی نهێنی بنووسە",
            "loginSuccessful": "چوونەژوورەوە سەرکەوتووبوو",
            "loginFailed": "چوونەژوورەوە سەرکەوتوو نەبوو",
            "search": "گەڕان",
            "filter": "فلتەرکردن",
            "actions": "کردارەکان",
            "status": "دۆخ",
            "active": "چالاک",
            "inactive": "ناچالاک",
            "loading": "بارکردن...",
            "profile": "پرۆفایل",
            "settings": "ڕێکخستنەکان",
            "personalInformation": "زانیاری کەسی",
            "notProvided": "نەدراوە",
            "changePassword": "گۆڕینی وشەی نهێنی",
            "updatePassword": "نوێکردنەوەی وشەی نهێنی",
            "currentPassword": "وشەی نهێنی ئێستا",
            "newPassword": "وشەی نهێنی نوێ",
            "confirmPassword": "پشتڕاستکردنەوەی وشەی نهێنی",
            "passwordUpdatedSuccessfully": "وشەی نهێنی بە سەرکەوتوویی نوێکرایەوە",
            "failedToUpdatePassword": "نوێکردنەوەی وشەی نهێنی سەرکەوتوو نەبوو",
            "passwordsDoNotMatch": "وشەکانی نهێنی یەکناگرنەوە",
            "pleaseEnterCurrentPassword": "تکایە وشەی نهێنی ئێستا بنووسە",
            "pleaseEnterNewPassword": "تکایە وشەی نهێنی نوێ بنووسە",
            "passwordMustBeAtLeast6Characters": "وشەی نهێنی دەبێت لانیکەم ٦ پیت بێت",
            "pleaseConfirmPassword": "تکایە وشەی نهێنی پشتڕاست بکەوە",
            "languageSettings": "ڕێکخستنەکانی زمان",
            "selectYourPreferredLanguage": "زمانی دڵخوازت هەڵبژێرە",
            "notificationSettings": "ڕێکخستنەکانی ئاگادارکردنەوە",
            "enableNotifications": "چالاککردنی ئاگادارکردنەوەکان",
            "emailNotifications": "ئاگادارکردنەوەکانی ئیمەیڵ",
            "displaySettings": "ڕێکخستنەکانی پیشاندان",
            "darkMode": "دۆخی تاریک",
            "darkModeComingSoon": "دۆخی تاریک بەزووانە دێت",
            "saveSettings": "پاشەکەوتکردنی ڕێکخستنەکان",
            "settingsSaved": "ڕێکخستنەکان پاشەکەوتکران",
            "reset": "ڕێکخستنەوە",
            "automaticDatabaseBackup": "باکئەپی خۆکارانەی بنکەدراوە",
            "backupDescription": "باکئەپی بنکەدراوە بە شێوەیەکی خۆکار هەموو شەوێک دەنێردرێت بۆ ئیمەیڵەکەت",
            "enableAutomaticBackup": "چالاککردنی باکئەپی خۆکار",
            "backupEmail": "ئیمەیڵی باکئەپ",
            "pleaseEnterValidEmail": "تکایە ئیمەیڵێکی دروست بنووسە",
            "pleaseEnterBackupEmail": "تکایە ئیمەیڵی باکئەپ بنووسە",
            "backupEmailHelp": "باکئەپەکە دەنێردرێت بۆ ئەم ئیمەیڵە",
            "backupTime": "کاتی باکئەپ",
            "backupTimeHelp": "کاتێک هەڵبژێرە کە باکئەپەکە هەموو ڕۆژێک بنێردرێت",
            "saveBackupSettings": "پاشەکەوتکردنی ڕێکخستنەکانی باکئەپ",
            "sendTestBackup": "ناردنی باکئەپی تاقیکردنەوە",
            "backupSettingsSaved": "ڕێکخستنەکانی باکئەپ پاشەکەوتکرا",
            "failedToSaveBackupSettings": "پاشەکەوتکردنی ڕێکخستنەکانی باکئەپ سەرکەوتوو نەبوو",
            "backupEmailSent": "ئیمەیڵی باکئەپ نێردرا",
            "failedToSendBackup": "ناردنی باکئەپ سەرکەوتوو نەبوو",

            // Students
            "studentId": "ژمارەی قوتابی",
            "firstName": "ناوی یەکەم",
            "lastName": "ناوی کۆتایی",
            "email": "ئیمەیڵ",
            "phone": "تەلەفۆن",
            "dateOfBirth": "ڕێکەوتی لەدایکبوون",
            "gender": "ڕەگەز",
            "male": "نێر",
            "female": "مێ",
            "other": "هیتر",
            "degree": "بڕوانامە",
            "studyingType": "جۆری خوێندن",
            "selectStudyingType": "جۆری خوێندن هەڵبژێرە",
            "inClass": "لە پۆل",
            "liveOnline": "ڕاستەوخۆ بە ئۆنلاین",
            "vip": "تایبەت",
            "recorded": "تۆمارکراو",
            "classStartHour": "کاتی دەستپێکی پۆل",
            "classEndHour": "کاتی کۆتایی پۆل",
            "howYouHeardUs": "چۆن هەواڵی ئێمەت بیست؟",
            "selectHowYouHeardUs": "هەڵبژێرە",
            "instagram": "ئینستاگرام",
            "tiktok": "تیکتۆک",
            "facebook": "فەیسبووک",
            "friend": "هاوڕێ",
            "howYouHeardUsOther": "ئەگەر هیتر، دیاری بکە",
            "specifyOther": "دیاری بکە",
            "pleaseSpecifyOther": "تکایە دیاری بکە",
            "enrolledCourses": "کۆرسە تۆمارکراوەکان",
            "addStudent": "زیادکردنی قوتابی",
            "courseFees": "نرخی کۆرس",
            "remainingAmount": "بڕی ماوە",
            "addAcademy": "زیادکردنی ئەکادیمی",
            "editAcademy": "دەستکاریکردنی ئەکادیمی",
            "addNewAcademy": "زیادکردنی ئەکادیمیی نوێ",
            "subscription": "بەشداری",
            "editStudent": "دەستکاریکردنی قوتابی",
            "studentDetails": "وردەکاریەکانی قوتابی",
            "classTime": "کاتی پۆل",
            "address": "ناونیشان",
            "studentSignature": "واژووی قوتابی",
            "invoiceTo": "پسولە بۆ",
            "invoiceDetails": "وردەکاریەکانی پسولە",
            "termsAndConditions": "تێبینی",
            "contactUs": "پەیوەندی کردن بە ئێمە",
            "advisoryTelephone": "ژمارەی تەلەفۆن",
            "invoiceNo": "ژمارەی پسولە",

            // Staff
            "staffId": "ژمارەی کارمەند",
            "name": "ناو",
            "position": "پێگە",
            "salary": "مووچە",
            "teacher": "مامۆستا",
            "admin": "بەڕێوەبەر",
            "reception": "پێشوازگر",
            "addStaff": "زیادکردنی کارمەند",
            "editStaff": "دەستکاریکردنی کارمەند",
            "commissionSettings": "ڕێکخستنەکانی کۆمیشن",
            "enableCommission": "چالاککردنی کۆمیشن",
            "commissionType": "جۆری کۆمیشن",
            "percentage": "ڕێژە",
            "fixedAmount": "بڕێکی دیاریکراو",
            "commissionPercentage": "ڕێژەی کۆمیشن",
            "fixedCommissionAmount": "بڕی کۆمیشنی دیاریکراو",
            "appliesTo": "بەکارهێنراو بۆ",
            "courseIncome": "داهاتی کۆرس",
            "allIncome": "هەموو داهاتەکان",
            "specificCourses": "کۆرسە دیاریکراوەکان",
            "selectCourses": "کۆرسەکان هەڵبژێرە",
            "commission": "کۆمیشن",
            "none": "هیچ",
            "of": "لە",
            "fixed": "دیاریکراو",
            "perCourse": "بۆ هەر کۆرسێک",

            // Courses
            "courseName": "ناوی کۆرس",
            "courseCode": "کۆدی کۆرس",
            "instructor": "مامۆستا",
            "duration": "ماوە",
            "fee": "کرێ",
            "language": "زمان",
            "level": "ئاست",
            "days": "ڕۆژ",
            "weeks": "هەفتە",
            "months": "مانگ",
            "unit": "یەکە",
            "minCapacity": "کەمترین ژمارە",
            "maxCapacity": "زۆرترین ژمارە",
            "selectInstructor": "مامۆستایەک هەڵبژێرە",
            "addCourse": "زیادکردنی کۆرس",
            "editCourse": "دەستکاریکردنی کۆرس",
            "courseDetails": "وردەکاریەکانی کۆرس",
            "subjects": "بابەتەکان",
            "subject": "بابەت",
            "subjectName": "ناوی بابەت",
            "addSubject": "زیادکردنی بابەت",
            "editSubject": "دەستکاریکردنی بابەت",
            "selectSubject": "بابەتێک هەڵبژێرە",
            "courseCompletedSuccessfully": "کۆرس بە سەرکەوتوویی تەواوکرا و بڕوانامەکان دروستکران",
            "failedToCompleteCourse": "تەواوکردنی کۆرس سەرکەوتوو نەبوو",
            "complete": "تەواوکردن",
            "courseExpenses": "خەرجیەکانی کۆرس",
            "addCourseExpense": "زیادکردنی خەرجی کۆرس",
            "expenses": "خەرجی",
            "expenseAddedSuccessfully": "خەرجی بە سەرکەوتوویی زیادکرا",
            "pleaseEnterDescription": "تکایە وردەکاری بنووسە",
            "expenseDescriptionPlaceholder": "وەک: ڕێکلامکردن لە سۆشیاڵ میدیا، مادەی خوێندن، هتد",
            "pleaseEnterAmount": "تکایە بڕەکە بنووسە",
            "pleaseSelectCurrency": "تکایە دراو هەڵبژێرە",
            "socialMedia": "سۆشیاڵ میدیا",
            "advertising": "ڕێکلامکردن",
            "materials": "مادەکان",
            "additionalNotes": "تێبینییە زیادەکان",
            "completeCourseConfirm": "دڵنیایت لە تەواوکردنی ئەم کۆرسە؟",
            "completeCourseDescription": "ئەمە کۆرسەکە وەک تەواوکراو دەژمێرێت و بڕوانامە بۆ هەموو قوتابیەکان دروست دەکات",
            "yes": "بەڵێ",
            "no": "نەخێر",

            // Finance
            "totalIncome": "کۆی داهات",
            "totalExpenses": "کۆی خەرجی",
            "totalDiscount": "کۆی داشکاندن",
            "netProfit": "قازانجی بێ خاو",
            "amount": "بڕ",
            "date": "ڕێکەوت",
            "description": "وردەکاری",
            "category": "جۆر",
            "addIncome": "زیادکردنی داهات",
            "addExpense": "زیادکردنی خەرجی",
            "incomeRecordAdded": "تۆمارکردنی داهات زیادکرا",
            "expenseRecordAdded": "تۆمارکردنی خەرجی زیادکرا",
            "failedToAddIncome": "زیادکردنی داهات سەرکەوتوو نەبوو",
            "failedToAddExpense": "زیادکردنی خەرجی سەرکەوتوو نەبوو",
            "pleaseSelectCategory": "تکایە جۆرێک هەڵبژێرە",
            "typeOrSelectCategory": "جۆرێک بنووسە یان هەڵبژێرە",
            "totalAfterDiscount": "کۆی گشتی دوای داشکاندن",
            "pleaseEnterAmount": "تکایە بڕەکە بنووسە",
            "tuition": "کرێی خوێندن",
            "registration": "تۆمارکردن",
            "other": "هیتر",
            "rent": "کرێ",
            "utilities": "خزمەتگوزاریەکان",
            "salary": "مووچە",
            "supplies": "پێداویستیەکان",
            "cash": "کاش",
            "onlinePayment": "پارەدانی ئۆنلاین",
            "bank": "بانک",
            "currency": "دراو",
            "USD": "دۆلاری ئەمریکی",
            "IQD": "دیناری عێراقی",
            "create": "دروستکردن",
            "autoGenerated": "خۆکار دروستکراو",
            "paymentFrequency": "ژمارەی جار لە پارەدان",
            "weekly": "هەفتانە",
            "daily": "ڕۆژانە",
            "joinDate": "ڕێکەوتی پەیوەستبوون",
            "employmentType": "جۆری دامەزراندن",
            "department": "بەش",
            "staffNotFound": "کارمەند نەدۆزرایەوە",
            "teachingCourses": "کۆرسە فێرکراوەکان",
            "notTeachingAnyCourses": "هیچ کۆرسێک فێرناکات",
            "cancel": "هەڵوەشاندنەوە",

            // Reports
            "financialReports": "ڕاپۆرتی دارایی",
            "transactions": "مامەڵەکان",
            "profit": "قازانج",
            "loss": "زەرەر",
            "profitMargin": "ڕێژەی قازانج",
            "ofTotalIncome": "لە کۆی داهات",
            "totalStudents": "کۆی قوتابیان",
            "totalStaff": "کۆی کارمەندان",
            "avgIncomePerTransaction": "ناوەندی داهات بۆ هەر مامەڵەیەک",
            "avgExpensePerTransaction": "ناوەندی خەرجی بۆ هەر مامەڵەیەک",
            "thisMonth": "ئەم مانگە",
            "incomeVsExpenses": "داهات دژ بە خەرجی",
            "financialDistribution": "دابەشکردنی دارایی",
            "monthlyTrend": "ڕەوتی مانگانە",
            "enrollmentTrend": "ڕەوتی تۆمارکردن",
            "incomeBreakdown": "دابەشکردنی داهات",
            "expenseBreakdown": "دابەشکردنی خەرجی",
            "incomeDetails": "وردەکاریەکانی داهات",
            "expenseDetails": "وردەکاریەکانی خەرجی",
            "percentage": "ڕێژە",
            "total": "کۆی گشتی",
            "items": "بابەت",
            "followUs": "لەگەڵمان بە لە",
            "pageTotal": "کۆی لاپەڕە",
            "activeStudents": "قوتابیانی چالاک",
            "activeStaff": "کارمەندانی چالاک",
            "courseRevenue": "داهاتی کۆرسەکان",
            "discountAmount": "بڕی داشکاندن",
            "salaryExpenses": "خەرجی مووچە",
            "courseEnrollmentStats": "ئاماری تۆمارکردنی کۆرسەکان",
            "courseReport": "ڕاپۆرتی کۆرس",
            "generalReports": "ڕاپۆرتە گشتیەکان",
            "selectCourse": "کۆرسێک هەڵبژێرە",
            "selectCourseToViewReport": "کۆرسێک هەڵبژێرە بۆ بینینی ڕاپۆرت",
            "courseInformation": "زانیاری کۆرس",
            "totalCommission": "کۆی کۆمیشن",
            "profitCalculation": "ژمێرینی قازانج",
            "staffCommissions": "کۆمیشنی کارمەندان",
            "commissionValue": "نرخی کۆمیشن",
            "commissionAmount": "بڕی کۆمیشن",
            "staffReport": "ڕاپۆرتی کارمەندان",
            "selectStaff": "کارمەندێک هەڵبژێرە",
            "selectStaffToViewReport": "کارمەندێک هەڵبژێرە بۆ بینینی ڕاپۆرت",
            "staffInformation": "زانیاری کارمەند",
            "totalSalary": "کۆی مووچە",
            "monthlySalary": "مووچەی مانگانە",
            "dateRange": "ماوەی کات",
            "paymentHistory": "مێژووی پارەدان",
            "salaryRecords": "تۆمارەکانی مووچە",
            "commissionBreakdown": "دابەشکردنی کۆمیشن",
            "coursesTeaching": "کۆرسە فێرکراوەکان",
            "studentsEnrolled": "قوتابیانی تۆمارکراو",
            "financialOverview": "پێناسەی دارایی",
            "studentPaymentStatus": "دۆخی پارەدانی قوتابیان",
            "revenueDistribution": "دابەشکردنی داهات",
            "fullyPaid": "تەواو پارەدراو",
            "partiallyPaid": "بەشێک پارەدراو",
            "reactivateCourse": "دووبارە چالاککردنی کۆرس",
            "unpaid": "پارەنەدراو",
            "incomeBreakdown": "دابەشکردنی داهات",
            "coursePerformance": "کارایی کۆرس",
            "salaryTrend": "ڕەوتی مووچە",
            "studentCount": "ژمارەی قوتابیان",
            "income": "داهات",
            "source": "سەرچاوە",
            "baseAmount": "بڕی بنەڕەت",
            "paidDate": "ڕێکەوتی پارەدان",
            "enrollmentDate": "ڕێکەوتی تۆمارکردن",
            "activeCourses": "کۆرسە چالاکەکان",
            "completedCourses": "کۆرسە تەواوکراوەکان",
            "statistics": "ئامار",
            "enrolledStudents": "قوتابیانی تۆمارکراو",
            "enrolledStudentsList": "لیستی قوتابیە تۆمارکراوەکان",
            "studentPaymentDetails": "وردەکاریەکانی پارەدانی قوتابی",
            "courseDetails": "وردەکاریەکانی کۆرس",
            "paymentDetails": "وردەکاریەکانی پارەدان",
            "paidAmount": "بڕی دراو",
            "pendingAmount": "بڕی ماوە",
            "invoice": "پسولە",
            "incomeReceipt": "پسولەی داهات",
            "expenseReceipt": "پسولەی خەرجی",
            "print": "چاپکردن",
            "preview": "پێشبینین",
            "close": "داخستن",
            "languageInstituteManagementSystem": "سیستەمی بەڕێوەبردنی پەیمانگای زمان",
            "generatedOn": "دروستکرا لە",
            "authorizedSignature": "واژوو",
            "verificationCode": "کۆدی پشتڕاستکردنەوە",
            "unpaidStudents": "قوتابیانی پارەنەدراو",
            "studentName": "ناوی قوتابی",
            "totalFee": "کۆی کرێ",
            "remainingAmount": "بڕی ماوە",
            "paymentStatus": "دۆخی پارەدان",
            "paymentInvoice": "پسولەی پارەدان",
            "paid": "دراوە",
            "partial": "بەشێک دراوە",
            "pending": "چاوەڕوانی",
            "term1": "ئەگەر مامۆستا نەیتوانی وانەیەک ئامادە بێت، بەهەرهۆکارێک، ئەوا وانەکە بۆ قوتابیان قەرەبوو دەکرێتەوە.",
            "term2": "ئەو بڕەپارەی کە دراوە بەهیچ هۆکارێک ناگەڕیتەوە",
            "term3": "ئەگەر خوێندکار لە 3 وانە زیاتر بەژداری نەکرد ، ئەوا دوای تەواوبوون بڕوانامەی پێنادرێت",
            "courseAmount": "کۆی گشتی",
            "discount": "داشکاندن",
            "remainAmount": "بڕی ماوە",
            // Invoices
            "createInvoice": "دروستکردنی پسولە",
            "editInvoice": "دەستکاریکردنی پسولە",
            "invoiceNumber": "ژمارەی پسولە",
            "invoiceDate": "ڕێکەوتی پسولە",
            "dueDate": "ڕێکەوتی کۆتایی",
            "client": "کڕیار",
            "clientName": "ناوی کڕیار",
            "clientEmail": "ئیمەیڵی کڕیار",
            "clientPhone": "تەلەفۆنی کڕیار",
            "totalAmount": "کۆی گشتی",
            "subtotal": "کۆی لاوەکی",
            "tax": "باج",
            "discount": "داشکاندن",
            "items": "بابەتەکان",
            "quantity": "بڕ",
            "unitPrice": "نرخی یەکە",
            "addItem": "زیادکردنی بابەت",
            "pleaseSelectType": "تکایە جۆرێک هەڵبژێرە",
            "selectType": "جۆرێک هەڵبژێرە",
            "selectStudent": "قوتابیەک هەڵبژێرە",
            "selectStaff": "کارمەندێک هەڵبژێرە",
            "selectCourse": "کۆرسێک هەڵبژێرە",
            "enterClientName": "ناوی کڕیار بنووسە",
            "enterClientEmail": "ئیمەیڵی کڕیار بنووسە",
            "enterClientPhone": "تەلەفۆنی کڕیار بنووسە",
            "enterNotes": "تێبینیەکان بنووسە",
            "draft": "ڕەشنووس",
            "sent": "نێردراوە",
            "cancelled": "هەڵوەشاوەتەوە",
            "payment": "پارەدان",
            "receipt": "پسولە",
            "receiptInvoice": "پسولەی وەرگرتن",
            "recordPayment": "تۆمارکردنی پارەدان",
            "discount": "داشکاندن",
            "totalAfterDiscount": "کۆی گشتی دوای داشکاندن",
            "discountCannotExceedAmount": "داشکاندن ناتوانێت زیاتر بێت لە بڕەکە",
            "paymentAmount": "بڕی پارەدان",
            "paymentDate": "بەرواری پارەدان",
            "selectPaymentMethod": "شێوازی پارەدان هەڵبژێرە",
            "card": "کارت",
            "online": "ئۆنلاین",
            "notes": "تێبینیەکان",
            "billTo": "بۆ",
            "update": "نوێکردنەوە",
            "invoiceCreatedSuccessfully": "پسولە بەسەرکەوتوویی دروستکرا",
            "invoiceUpdatedSuccessfully": "پسولە بەسەرکەوتوویی نوێکرایەوە",
            "invoiceDeletedSuccessfully": "پسولە بەسەرکەوتوویی سڕایەوە",
            "failedToCreateInvoice": "دروستکردنی پسولە سەرکەوتوو نەبوو",
            "failedToUpdateInvoice": "نوێکردنەوەی پسولە سەرکەوتوو نەبوو",
            "failedToDeleteInvoice": "سڕینەوەی پسولە سەرکەوتوو نەبوو",
            "paymentRecordedSuccessfully": "پارەدان بەسەرکەوتوویی تۆمارکرا",
            "failedToRecordPayment": "تۆمارکردنی پارەدان سەرکەوتوو نەبوو",
            "paymentReceipt": "پسوڵەی پارەدان",
            "languageInstitute": "پەیمانگای فێرکردنی زمان",
            "studentInformation": "زانیاری قوتابی",
            "receiptDetails": "وردەکاریەکانی پسوڵە",
            "receiptNumber": "ژمارەی پسوڵە",
            "totalCourseFee": "کۆی کرێی کۆرس",
            "amountPaid": "بڕی پارەدراو",
            "totalPaidToDate": "کۆی پارەدراو تاکو ئێستا",
            "remainingBalance": "ماوەی پارە",
            "paymentStatus": "دۆخی پارەدان",
            "thankYouForPayment": "سوپاس بۆ پارەدانەکەت!",
            "computerGeneratedReceipt": "ئەمە پسوڵەیەکی کۆمپیوتەرییە و پێویستی بە واژوو نییە",
            "printedOn": "چاپکرا لە",
            "payAmount": "پارەی دراو",

            // Messages
            "createdSuccessfully": "بەسەرکەوتوویی دروستکرا",
            "updatedSuccessfully": "بەسەرکەوتوویی نوێکرایەوە",
            "deletedSuccessfully": "بەسەرکەوتوویی سڕایەوە",
            "confirmDelete": "دڵنیایت لە سڕینەوەی ئەم بابەتە؟",
            "actionCannotBeUndone": "ئەم کردارە ناگەڕێتەوە",
            "removeCourseConfirm": "ئەم کۆرسە لە قوتابی لاببردرێت؟ تۆمارەکانی پارەدان دەمێننەوە.",
            "removeCourse": "لابردنی کۆرس",
            "removeCourseOnSave": "کۆرسەکە لادەبردرێت کاتێک پاشەکەوتی دەکەیت.",
            "cannotRemoveLastCourse": "دەبێت قوتابی بەلایەنی کەمەوە یەک کۆرسی هەبێت.",

            // Filters
            "filterByCourse": "فلتەرکردن بە کۆرس",
            "filterByGroup": "فلتەرکردن بە گروپ",
            "filterByStatus": "فلتەرکردن بە دۆخ",
            "filterByCategory": "فلتەرکردن بە جۆر",
            "printSelected": "چاپکردنی هەڵبژێردراوەکان",
            "selectAll": "هەڵبژاردنی هەموو",
            "deselectAll": "لابردنی هەموو",
            "printCertificates": "چاپکردنی بڕوانامەکان",
            "noCertificatesFound": "هیچ بڕوانامەیەک نەدۆزرایەوە",
            "filterByPosition": "فلتەرکردن بە پێگە",
            "filterByInstructor": "فلتەرکردن بە مامۆستا",
            "searchByNameOrEmail": "گەڕان بە ناو یان ئیمەیڵ",
            "searchByNameOrCode": "گەڔان بە ناو یان کۆد",

            // Table Headers
            "code": "کۆد",
            "actions": "کردارەکان",
            "receiptNo": "ژمارەی پسولە",
            "certificateNo": "ژمارەی بڕوانامە",
            "student": "قوتابی",
            "studentNotFound": "قوتابی نەدۆزرایەوە",
            "coursesAttended": "کۆرسە بەشداربووەکان",
            "back": "گەڕانەوە",
            "course": "کۆرس",
            "courseNotFound": "کۆرس نەدۆزرایەوە",
            "totalIncome": "کۆی داهات",
            "enrolledStudents": "قوتابییە تۆمارکراوەکان",
            "ended": "کۆتایی هاتووە",
            "markAsEnded": "وەک کۆتاییهاتوو دیاریکراو",
            "endThisCourse": "کۆتایی ئەم کۆرسە بهێنرێت؟",
            "endCourseConfirmation": "ئەمە کۆرسەکە وەک کۆتاییهاتوو دیاردەکات و تۆمارکردنی زیاتر داخدەکات.",
            "courseMarkedAsEnded": "کۆرسەکە وەک کۆتاییهاتوو دیاریکرا",
            "failedToEndCourse": "کۆتاییهێنانی کۆرس سەرکەوتوو نەبوو",
            "confirm": "دڵنیاکردنەوە",
            "issueDate": "ڕێکەوتی دەرکردن",
            "paymentMethod": "شێوازی پارەدان",
            "role": "ڕۆڵ",
            "academy": "ئەکادیمی",

            // User Management
            "addUser": "زیادکردنی بەکارهێنەر",
            "editUser": "دەستکاریکردنی بەکارهێنەر",
            "createUser": "دروستکردنی بەکارهێنەر",
            "updateUser": "نوێکردنەوەی بەکارهێنەر",
            "userCreatedSuccessfully": "بەکارهێنەر بەسەرکەوتوویی دروستکرا",
            "userUpdatedSuccessfully": "بەکارهێنەر بەسەرکەوتوویی نوێکرایەوە",
            "userDeletedSuccessfully": "بەکارهێنەر بەسەرکەوتوویی سڕایەوە",
            "failedToCreateUser": "دروستکردنی بەکارهێنەر سەرکەوتوو نەبوو",
            "failedToUpdateUser": "نوێکردنەوەی بەکارهێنەر سەرکەوتوو نەبوو",
            "confirmDeleteUser": "دڵنیایت لە سڕینەوەی ئەم بەکارهێنەرە؟",
            "superAdmin": "بەڕێوەبەری گشتی",
            "dataEntry": "تۆمارکردنی زانیاری",
            "selectRole": "ڕۆڵێک هەڵبژێرە",
            "selectAcademy": "ئەکادیمیەک هەڵبژێرە",
            "pleaseEnterFirstName": "تکایە ناوی یەکەم بنووسە",
            "pleaseEnterLastName": "تکایە ناوی کۆتایی بنووسە",
            "pleaseEnterEmail": "تکایە ئیمەیڵ بنووسە",
            "pleaseEnterValidEmail": "تکایە ئیمەیڵێکی دروست بنووسە",
            "pleaseSelectRole": "تکایە ڕۆڵێک هەڵبژێرە",
            "pleaseSelectAcademy": "تکایە ئەکادیمیەک هەڵبژێرە",
            "pleaseEnterPassword": "تکایە وشەی نهێنی بنووسە",
            "password": "وشەی نهێنی",
            "passwordLeaveBlank": "وشەی نهێنی (بەتاڵی بهێڵەرەوە بۆ هەمان وشە)",
            "passwordMinLength": "وشەی نهێنی دەبێت لانیکەم ٦ پیت بێت",
            "startDate": "ڕێکەوتی دەستپێک",
            "endDate": "ڕێکەوتی کۆتایی",
            "autoGeneratedIfLeftBlank": "خۆکارانە دروست دەکرێت ئەگەر بەتاڵ بهێڵدرێتەوە",
            "pleaseEnterPhone": "تکایە ژمارەی تەلەفۆن بنووسە",
            "selectDate": "ڕێکەوتێک هەڵبژێرە",
            "selectGender": "ڕەگەزێک هەڵبژێرە",
            "selectCourse": "کۆرسێک هەڵبژێرە",
            "selectStatus": "دۆخێک هەڵبژێرە",
            "assignToCourse": "تەرخانکردن بۆ کۆرس",
            "assignCourses": "تەرخانکردن بۆ کۆرسەکان",
            "duplicateCourseInList": "ناتوانیت هەمان کۆرس دووجار دیاری بکەیت",
            "group": "گروپ",
            "selectGroup": "گروپ هەڵبژێرە",
            "courseGroups": "گروپەکانی کۆرس",
            "courseGroupsTooltip": "گروپەکان بۆ ئەم کۆرسە دیاری بکە (وەک Group A، Group B)",
            "graduated": "دەرچوو",
            "withdrawn": "کشایەوە",
            "createStudent": "دروستکردنی قوتابی",
            "updateStudent": "نوێکردنەوەی قوتابی",
            "auditLogs": "تۆمارەکانی چاودێری",
            "totalActions": "کۆی گشتی کردارەکان",
            "successfulActions": "کردارە سەرکەوتووانەکان",
            "failedActions": "کردارە سەرکەوتوو نەبووانەکان",
            "uniqueUsers": "بەکارهێنەرە تایبەتییەکان",
            "cleanOld": "پاککردنەوەی کۆنەکان",
            "auditLogDetails": "وردەکاریەکانی تۆمارە چاودێری",
            "timestamp": "کاتژمێر",
            "resource": "سەرچاوە",
            "ipAddress": "ناونیشانی ئایپی",
            "userAgent": "ئایجێنتی بەکارهێنەر",
            "affectsCommission": "ئەم کردارە کۆمیشن دەکات",
            "affectsCommissionTooltip": "ئەگەر ئەم هەڵبژاردەیە چالاک بێت، ئەوا ئەم کردارە کۆمیشن دەکات و لە ڕاپۆرتی کۆمیشنیش نیشان دەدرێت.",
            "errorMessage": "پەیامی هەڵە",
            "details": "وردەکاریەکان",
            "refresh": "نوێکردنەوە",
            "selectResource": "سەرچاوەیەک هەڵبژێرە",
            "selectStatus": "دۆخێک هەڵبژێرە",
            "deleteLogsOlderThan90Days": "سڕینەوەی تۆمارەکان کۆنتر لە ٩٠ ڕۆژ",
            "selectAction": "کردارێک هەڵبژێرە",
            "cleanOld": "پاککردنەوەی کۆنەکان",
            "action": "کردار",
            "user": "بەکارهێنەر",
            // Certificate Templates
            "certificateTemplates": "تێمپڵەتەکانی بڕوانامە",

            // Social Messaging
            "Social Messaging": "پەیامە کۆمەڵایەتیەکان",
            "Messages": "پەیامەکان",
            "Integrations": "یەکخستنەکان",
            "Platform": "پلاتفۆرم",
            "Sender": "ناردنەوە",
            "Message": "پەیام",
            "Reply": "وەڵام",
            "Convert": "گۆڕین",
            "to Student": "بۆ قوتابی",
            "Reply to": "وەڵامدانەوە بۆ",
            "Original Message": "پەیامی ڕەسەن",
            "Your Reply": "وەڵامەکەت",
            "Please enter your reply": "تکایە وەڵامەکەت بنووسە",
            "Type your reply here...": "وەڵامەکەت لێرە بنووسە...",
            "Send Reply": "ناردنی وەڵام",
            "Reply sent successfully": "وەڵام بە سەرکەوتوویی نێردرا",
            "Failed to send reply": "ناردنی وەڵام سەرکەوتوو نەبوو",
            "Convert to Student": "گۆڕین بۆ قوتابی",
            "Successfully converted to student": "بە سەرکەوتوویی گۆڕدرا بۆ قوتابی",
            "Failed to convert to student": "گۆڕین بۆ قوتابی سەرکەوتوو نەبوو",
            "Assign to Course (Optional)": "دیاریکردنی کۆرس (ئارەزوومەندانە)",
            "Select a course": "کۆرسێک هەڵبژێرە",
            "Total Messages": "کۆی گشتی پەیامەکان",
            "Pending": "چاوەڕوان",
            "Unread": "نەخوێندراوە",
            "Converted": "گۆڕدراوە",
            "Search by name, phone, or message": "گەڕان بە ناو، ژمارەی مۆبایل، یان پەیام",
            "Filter by platform": "فلتەرکردن بە پلاتفۆرم",
            "Filter by status": "فلتەرکردن بە دۆخ",
            "Replied": "وەڵامدراوەتەوە",
            "Archived": "ئەرشیفکراوە",
            "Mark as Read": "نیشانکردن وەک خوێندراوە",
            "Reply": "وەڵامدانەوە",
            "Connect Your Social Platforms": "پلاتفۆرمە کۆمەڵایەتیەکانت بەستەوە",
            "Receive and reply to messages from WhatsApp, Facebook, and Instagram directly in your academy dashboard. Convert leads to students with one click.": "وەرگرتن و وەڵامدانەوەی پەیامەکان لە واتساپ، فەیسبووک و ئینستاگرامەوە ڕاستەوخۆ لە داشبۆردی ئەکادیمیەکەتدا. گۆڕینی کڕیارەکان بۆ قوتابی بە یەک کرتە.",
            "Save Configuration": "پاشەکەوتکردنی ڕێکخستن",
            "Integration saved successfully": "یەکخستن بە سەرکەوتوویی پاشەکەوت کرا",
            "Failed to save integration": "پاشەکەوتکردنی یەکخستن سەرکەوتوو نەبوو",
            "Integration status updated": "دۆخی یەکخستن نوێکرایەوە",
            "Failed to update status": "نوێکردنەوەی دۆخ سەرکەوتوو نەبوو",
            "Copied to clipboard": "کۆپیکرا",
            "createTemplate": "دروستکردنی تێمپڵەت",
            "editTemplate": "دەستکاریکردنی تێمپڵەت",
            "templateName": "ناوی تێمپڵەت",
            "pleaseEnterTemplateName": "تکایە ناوی تێمپڵەت بنووسە",
            "setAsDefault": "دانان وەک بنەڕەتی",
            "design": "دیزاین",
            "layout": "پلان",
            "classic": "کلاسیک",
            "modern": "مۆدێرن",
            "elegant": "جوان",
            "minimal": "کەمینە",
            "orientation": "ئاڕاستە",
            "landscape": "ئاسۆیی",
            "portrait": "ستوونی",
            "borderWidth": "پانی سنوور",
            "backgroundColor": "ڕەنگی پاشبنەما",
            "backgroundImage": "وێنەی پاشبنەما",
            "uploadBackground": "بارکردنی پاشبنەما",
            "currentBackground": "پاشبنەمای ئێستا",
            "borderColor": "ڕەنگی سنوور",
            "cornerDecorations": "زەخرەفەکانی گۆشە",
            "enableCornerDecorations": "چالاککردنی زەخرەفەکانی گۆشە",
            "decorationType": "جۆری زەخرەفە",
            "decorationColor": "ڕەنگی زەخرەفە",
            "decorationSize": "قەبارەی زەخرەفە",
            "floral": "گوڵدار",
            "geometric": "ئەندازیار",
            "ornamental": "ڕازاوە",
            "islamic": "ئیسلامی",
            "arabesque": "عەرەبی",
            "baroque": "باڕۆک",
            "celtic": "کێلتیک",
            "artDeco": "دیکۆڕ",
            "vintage": "کۆن",
            "modernCurves": "خولی مۆدێرن",
            "elegantSwirl": "خولی جوان",
            "royal": "شاهانە",
            "header": "سەرپەڕە",
            "instituteLogo": "لۆگۆی پەیمانگە",
            "uploadLogo": "باڕکردنی لۆگۆ",
            "currentLogo": "لۆگۆی ئێستا",
            "instituteName": "ناوی پەیمانگە",
            "instituteNameFont": "فۆنتی ناوی پەیمانگە",
            "fontFamily": "جۆری فۆنت",
            "fontSize": "قەبارەی فۆنت",
            "fontColor": "ڕەنگی فۆنت",
            "body": "ناوەڕۆک",
            "certificateTitle": "ناونیشانی بڕوانامە",
            "titleFont": "فۆنتی ناونیشان",
            "bodyText": "دەقی ناوەڕۆک",
            "template": "تێمپڵەت",
            "useVariables": "بەکارهێنانی گۆڕاوەکان",
            "availableVariables": "گۆڕاوە بەردەستەکان",
            "bodyFont": "فۆنتی ناوەڕۆک",
            "footer": "پێپەڕە",
            "showDate": "پیشاندانی ڕێکەوت",
            "showSignature": "پیشاندانی واژوو",
            "signatureLabel": "ناونیشانی واژوو",
            "signatureImage": "وێنەی واژوو",
            "uploadSignature": "باڕکردنی واژوو",
            "areYouSureDeleteInvoice": "دڵنیایت لە سڕینەوەی ئەم تێمپڵەتە؟",
            "currentSignature": "واژووی ئێستا",
            "default": "بنەڕەتی",
            "custom": "تایبەت",
            "setDefault": "دانان وەک بنەڕەتی",
            "previewTemplate": "پێشبینینی تێمپڵەت",
            "templateCreatedSuccessfully": "تێمپڵەت بەسەرکەوتوویی دروستکرا",
            "templateUpdatedSuccessfully": "تێمپڵەت بەسەرکەوتوویی نوێکرایەوە",
            "templateDeletedSuccessfully": "تێمپڵەت بەسەرکەوتوویی سڕایەوە",
            "errorCreatingTemplate": "هەڵە لە دروستکردنی تێمپڵەت",
            "errorUpdatingTemplate": "هەڵە لە نوێکردنەوەی تێمپڵەت",
            "errorDeletingTemplate": "هەڵە لە سڕینەوەی تێمپڵەت",
            "defaultTemplateSet": "تێمپڵەتی بنەڕەتی دانرا",
            "errorSettingDefault": "هەڵە لە دانانی بنەڕەتی",
            "confirmDeleteTemplate": "دڵنیایت لە سڕینەوەی ئەم تێمپڵەتە؟",
            "errorUploadingFiles": "هەڵە لە باڕکردنی فایلەکان",
            "basicInfo": "زانیاریی بنەڕەتی",
            "financialSummary": "پوختەی دارایی",
            "createdAt": "ڕێکەوتی تۆمارکردن",
            "registrationDate": "ڕێکەوتی تۆمارکردن",
            "lastPaymentDate": "دوایین پارەدان",
            "incomeSearchPlaceholder": "گەڕان بە ناو، ژمارەی وەسڵ، وەسف",
            "incomeGrandTotal": "کۆی گشتی",
            "incomeTotalsByName": "کۆ بەپێی ناو",
            "incomePrintReport": "چاپکردنی ڕاپۆرت",
            "incomePrintSelected": "چاپکردنی هەڵبژێردراو",
            "incomeRecordsCount": "ژمارەی تۆمار",
            "incomeReportTitle": "ڕاپۆرتی داهات",
            "incomeAllCategories": "هەموو پۆلەکان",
            "incomeSelectedCount": "هەڵبژێردراو",
            "customizeFormFields": "دیاریکردنی خانەکانی فۆرم",
            "customizeFormFieldsHint": "ئەو خانانەی دیاریکراون لە فۆرمی خوێندکار پیشان دەدرێن. ئەوانەی پێویستت نین لابەرە.",
            "emergencyPhone": "تەلەفۆنی فریاگوزاری",
            "refund": "گەڕاندنەوەی پارە",
            "refundInvoice": "گەڕاندنەوەی پارەی پسولە",
            "refundReceipt": "پسولەی گەڕاندنەوەی پارە",
            "refundAmount": "بڕی گەڕاندنەوە",
            "refundedAmount": "بڕی گەڕێندراوە",
            "alreadyRefunded": "پێشتر گەڕێندراوەتەوە",
            "maxRefundable": "زۆرترین بڕی گەڕاندنەوە",
            "refundMethod": "شێوازی گەڕاندنەوە",
            "refundReason": "هۆکاری گەڕاندنەوە",
            "enterRefundReason": "هۆکاری گەڕاندنەوە بنووسە (ئارەزوومەندانە)",
            "confirmRefund": "گەڕاندنەوەی پارە",
            "pleaseEnterRefundAmount": "تکایە بڕی گەڕاندنەوە بنووسە",
            "refundExceedsPaid": "بڕی گەڕاندنەوە لە بڕی پارەدراو زیاترە",
            "refundRecordedSuccessfully": "گەڕاندنەوەی پارە بە سەرکەوتوویی تۆمارکرا",
            "refundFailed": "گەڕاندنەوەی پارە سەرکەوتوو نەبوو",
            "totalRefunded": "کۆی گەڕێندراوە",
            "refunded": "گەڕێندراوەتەوە",
            "emergencyPhoneOwner": "خاوەنی تەلەفۆنی فریاگوزاری",
            "selectEmergencyPhoneOwner": "خاوەنی تەلەفۆن هەڵبژێرە",
            "father": "باوک",
            "mother": "دایک",
            "brother": "برا",
            "sister": "خوشک",
            "relative": "خزم",
            "school": "قوتابخانە",
            "enterSchool": "ناوی قوتابخانە بنووسە",
            "studyLanguage": "زمانی خوێندن",
            "selectStudyLanguage": "زمانی خوێندن هەڵبژێرە",
            "english": "ئینگلیزی",
            "kurdish": "کوردی",
            "duplicateStudentExists": "قوتابیێک بە ناوی \"{{name}}\" پێشتر هەیە (ژمارە: {{id}})",
            "failedToCreateStudent": "دروستکردنی قوتابی سەرکەوتوو نەبوو",
            "currentCourse": "کۆرسی ئێستا",
            "previousCourses": "کۆرسە پێشووەکان",
            "noActiveCourse": "هیچ کۆرسێکی چالاک نییە",

            // Payment Notifications
            "paymentNotifications": "ئاگادارکردنەوەی پارەدان",
            "activeNotifications": "ئاگادارکردنەوەی چالاک",
            "unreadNotifications": "ئاگادارکردنەوەی نەخوێندراوەکان",
            "overduePayments": "پارەدانی دوابەدر",
            "allNotifications": "هەموو ئاگادارکردنەوەکان",
            "urgentPayments": "پارەدانی فریاکارانە",
            "markAllAsRead": "هەموویان بەخوێندراو بنیشانە",
            "noNotifications": "هیچ ئاگادارکردنەوەیەک نییە",
            "noUrgentPayments": "هیچ پارەدانی فریاکارانەیەک نییە",
            "noOverduePayments": "هیچ پارەدانی دوابەدرێکی نییە",
            "remainingAmount": "بڕی ماوە",
            "paymentDeadline": "کۆتاپاشگا پارەدان",
            "markAsRead": "بەخوێندراو بنیشانە",
            "dismiss": "رەتکردنەوە",
            "overdue": "دوابەدر",
            "dueForPayment": "پێویستی بە پارەدان",
            "paymentCompleted": "پارەدان تەواوبوو",
            "daysOverdue": "ڕۆژ دوابەدر",
            "today": "ئەمڕۆ",
            "daysLeft": "ڕۆژ ماوە",
            "failedToUpdateNotification": "نوێکردنەوەی ئاگادارکردنەوە سەرکەوتوو نەبوو",
            "notificationDismissed": "ئاگادارکردنەوە رەتکرایەوە",
            "failedToDismissNotification": "رەتکردنەوەی ئاگادارکردنەوە سەرکەوتوو نەبوو",
            "paymentNotificationCompleted": "ئاگادارکردنەوە بەتەواوبوو نیشاندرا",
            "failedToCompleteNotification": "تەواوکردنی ئاگادارکردنەوە سەرکەوتوو نەبوو",
            "allNotificationsMarkedAsRead": "هەموو ئاگادارکردنەوەکان بەخوێندراو نیشاندران",
            "failedToMarkAsRead": "نیشاندانبەخوێندراو سەرکەوتوو نەبوو",
        }
    },
    ar: {
        translation: {
            // Navigation
            "dashboard": "لوحة التحكم",
            "academies": "الأكاديميات",
            "academic": "أكاديمي",
            "students": "الطلاب",
            "staff": "الموظفون",
            "courses": "الدورات",
            "finance": "المالية",
            "income": "الدخل",
            "expenses": "المصروفات",
            "certificates": "الشهادات",
            "invoices": "الفواتير",
            "reports": "التقارير",
            "users": "المستخدمون",
            "institute": "المعهد",
            "discountAmount": "مبلغ الخصم",

            // Recurring Expenses
            "addRecurringExpense": "إضافة مصروف متكرر",
            "editRecurringExpense": "تعديل مصروف متكرر",
            "recurringExpenseAdded": "تمت إضافة المصروف المتكرر",
            "recurringExpenseUpdated": "تم تحديث المصروف المتكرر",
            "recurringExpenseDeleted": "تم حذف المصروف المتكرر",
            "failedToAddRecurringExpense": "فشل في إضافة المصروف المتكرر",
            "failedToUpdateRecurringExpense": "فشل في تحديث المصروف المتكرر",
            "failedToDeleteRecurringExpense": "فشل في حذف المصروف المتكرر",
            "confirmDeleteRecurringExpense": "هل أنت متأكد من حذف هذا المصروف المتكرر؟",
            "expenseName": "اسم المصروف",
            "pleaseEnterExpenseName": "الرجاء إدخال اسم المصروف",
            "expenseNamePlaceholder": "مثال: إيجار المعهد، الكهرباء، الماء",
            "expenseType": "نوع المصروف",
            "pleaseSelectExpenseType": "الرجاء اختيار نوع المصروف",
            "selectExpenseType": "اختر نوع المصروف",
            "descriptionPlaceholder": "تفاصيل إضافية...",
            "frequency": "التكرار",
            "monthly": "شهريًا",
            "quarterly": "كل ثلاثة أشهر",
            "yearly": "سنويًا",
            "dayOfMonth": "يوم من الشهر",
            "startDate": "تاريخ البدء",
            "lastGenerated": "آخر إنشاء",
            "generateMonthlyExpenses": "إنشاء المصروفات الشهرية",
            "monthlyExpensesGenerated": "تم إنشاء المصروفات الشهرية",
            "failedToGenerateExpenses": "فشل في إنشاء المصروفات",
            "generateExpensesDescription": "ستضيف هذه العملية المصروفات المتكررة ورواتب الموظفين للشهر المحدد إلى النظام",
            "month": "الشهر",
            "year": "السنة",
            "generate": "إنشاء",
            "howItWorks": "كيف يعمل؟",
            "recurringExpensesDescription": "المصروفات المتكررة مثل الإيجار والكهرباء يتم إنشاؤها تلقائيًا كل شهر. رواتب الموظفين النشطين تُضاف تلقائيًا أيضًا.",

            // Month Names
            "january": "يناير",
            "february": "فبراير",
            "march": "مارس",
            "april": "أبريل",
            "may": "مايو",
            "june": "يونيو",
            "july": "يوليو",
            "august": "أغسطس",
            "september": "سبتمبر",
            "october": "أكتوبر",
            "november": "نوفمبر",
            "december": "ديسمبر",

            // Common
            "add": "إضافة",
            "followUs": "تابعنا",
            "edit": "تعديل",
            "delete": "حذف",
            "save": "حفظ",
            "cancel": "إلغاء",
            "login": "تسجيل الدخول",
            "logout": "تسجيل الخروج",
            "paymanga": "بيمانغا",
            "languageInstituteManagementSystem": "نظام إدارة معهد اللغات",
            "email": "البريد الإلكتروني",
            "password": "كلمة المرور",
            "pleaseInputEmail": "الرجاء إدخال بريدك الإلكتروني",
            "pleaseInputPassword": "الرجاء إدخال كلمة المرور",
            "loginSuccessful": "تم تسجيل الدخول بنجاح",
            "loginFailed": "فشل تسجيل الدخول",
            "search": "بحث",
            "filter": "تصفية",
            "actions": "الإجراءات",
            "status": "الحالة",
            "active": "نشط",
            "inactive": "غير نشط",
            "loading": "جاري التحميل...",
            "profile": "الملف الشخصي",
            "settings": "الإعدادات",
            "personalInformation": "المعلومات الشخصية",
            "notProvided": "غير محدد",
            "changePassword": "تغيير كلمة المرور",
            "updatePassword": "تحديث كلمة المرور",
            "currentPassword": "كلمة المرور الحالية",
            "newPassword": "كلمة المرور الجديدة",
            "confirmPassword": "تأكيد كلمة المرور",
            "passwordUpdatedSuccessfully": "تم تحديث كلمة المرور بنجاح",
            "failedToUpdatePassword": "فشل تحديث كلمة المرور",
            "passwordsDoNotMatch": "كلمات المرور غير متطابقة",
            "pleaseEnterCurrentPassword": "الرجاء إدخال كلمة المرور الحالية",
            "pleaseEnterNewPassword": "الرجاء إدخال كلمة المرور الجديدة",
            "passwordMustBeAtLeast6Characters": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
            "pleaseConfirmPassword": "الرجاء تأكيد كلمة المرور",
            "languageSettings": "إعدادات اللغة",
            "selectYourPreferredLanguage": "اختر لغتك المفضلة",
            "notificationSettings": "إعدادات الإشعارات",
            "enableNotifications": "تفعيل الإشعارات",
            "emailNotifications": "إشعارات البريد الإلكتروني",
            "displaySettings": "إعدادات العرض",
            "darkMode": "الوضع الداكن",
            "darkModeComingSoon": "الوضع الداكن قريبًا",
            "saveSettings": "حفظ الإعدادات",
            "settingsSaved": "تم حفظ الإعدادات",
            "reset": "إعادة تعيين",
            "automaticDatabaseBackup": "النسخ الاحتياطي التلقائي لقاعدة البيانات",
            "backupDescription": "سيتم إرسال نسخة احتياطية من قاعدة البيانات تلقائيًا كل ليلة إلى بريدك الإلكتروني",
            "enableAutomaticBackup": "تفعيل النسخ الاحتياطي التلقائي",
            "backupEmail": "البريد الإلكتروني للنسخ الاحتياطي",
            "pleaseEnterValidEmail": "الرجاء إدخال بريد إلكتروني صالح",
            "pleaseEnterBackupEmail": "الرجاء إدخال بريد النسخ الاحتياطي",
            "backupEmailHelp": "سيتم إرسال النسخة الاحتياطية إلى هذا البريد",
            "backupTime": "وقت النسخ الاحتياطي",
            "backupTimeHelp": "اختر الوقت الذي سيتم فيه إرسال النسخة الاحتياطية يوميًا",
            "saveBackupSettings": "حفظ إعدادات النسخ الاحتياطي",
            "sendTestBackup": "إرسال نسخة احتياطية تجريبية",
            "backupSettingsSaved": "تم حفظ إعدادات النسخ الاحتياطي",
            "failedToSaveBackupSettings": "فشل حفظ إعدادات النسخ الاحتياطي",
            "backupEmailSent": "تم إرسال النسخة الاحتياطية",
            "failedToSendBackup": "فشل إرسال النسخة الاحتياطية",
            "invoiceTo": "فاتورة إلى",
            "invoiceDetails": " تفاصيل الفاتورة",
            "termsAndConditions": "الملاحظة",
            "contactUs": "اتصل بنا",
            "advisoryTelephone": "هاتف الاستشارة",
            "invoiceNo": "رقم الفاتورة",

            // Students
            "studentId": "رقم الطالب",
            "firstName": "الاسم الأول",
            "lastName": "اسم العائلة",
            "email": "البريد الإلكتروني",
            "phone": "الهاتف",
            "dateOfBirth": "تاريخ الميلاد",
            "gender": "الجنس",
            "male": "ذكر",
            "female": "أنثى",
            "other": "آخر",
            "degree": "الشهادة",
            "studyingType": "نوع الدراسة",
            "selectStudyingType": "اختر نوع الدراسة",
            "inClass": "حضوري",
            "liveOnline": "ألكتروني",
            "vip": "VIP",
            "recorded": "دورة مسجلة",
            "classStartHour": "ساعة بدء الصف",
            "classEndHour": "ساعة انتهاء الصف",
            "howYouHeardUs": "كيف سمعت عنا؟",
            "selectHowYouHeardUs": "اختر",
            "instagram": "إنستغرام",
            "tiktok": "تيك توك",
            "facebook": "فيسبوك",
            "friend": "صديق",
            "howYouHeardUsOther": "إذا كان آخر، حدد",
            "specifyOther": "حدد",
            "pleaseSpecifyOther": "يرجى التحديد",
            "enrolledCourses": "الدورات المسجلة",
            "addStudent": "إضافة طالب",
            "courseFees": "سعر الدورة",
            "remainingAmount": "المبلغ المتبقي",
            "addAcademy": "إضافة أكاديمية",
            "editAcademy": "تعديل الأكاديمية",
            "addNewAcademy": "إضافة أكاديمية جديدة",
            "subscription": "الاشتراك",
            "editStudent": "تعديل الطالب",
            "studentDetails": "تفاصيل الطالب",
            "studentSignature": "توقيع الطالب",
            "classTime": "وقت الصف",
            "address": "العنوان",

            // Staff
            "staffId": "رقم الموظف",
            "name": "الاسم",
            "position": "المنصب",
            "salary": "الراتب",
            "teacher": "معلم",
            "admin": "مدير",
            "reception": "استقبال",
            "addStaff": "إضافة موظف",
            "editStaff": "تعديل الموظف",

            // Courses
            "courseName": "اسم الدورة",
            "courseCode": "رمز الدورة",
            "instructor": "المدرس",
            "duration": "المدة",
            "fee": "الرسوم",
            "language": "اللغة",
            "level": "المستوى",
            "days": "أيام",
            "weeks": "أسابيع",
            "months": "أشهر",
            "unit": "الوحدة",
            "minCapacity": "الحد الأدنى",
            "maxCapacity": "الحد الأقصى",
            "selectInstructor": "اختر المدرس",
            "addCourse": "إضافة دورة",
            "editCourse": "تعديل الدورة",
            "courseDetails": "تفاصيل الدورة",
            "subjects": "المواد",
            "subject": "المادة",
            "subjectName": "اسم المادة",
            "addSubject": "إضافة مادة",
            "editSubject": "تعديل المادة",
            "selectSubject": "اختر المادة",
            "courseCompletedSuccessfully": "تم إكمال الدورة بنجاح وإنشاء الشهادات",
            "failedToCompleteCourse": "فشل في إكمال الدورة",

            // Finance
            "totalIncome": "إجمالي الدخل",
            "totalExpenses": "إجمالي المصروفات",
            "netProfit": "صافي الربح",
            "amount": "المبلغ",
            "date": "التاريخ",
            "description": "الوصف",
            "category": "الفئة",
            "addIncome": "إضافة دخل",
            "addExpense": "إضافة مصروف",
            "incomeRecordAdded": "تمت إضافة سجل الدخل",
            "expenseRecordAdded": "تمت إضافة سجل المصروف",
            "failedToAddIncome": "فشل في إضافة الدخل",
            "failedToAddExpense": "فشل في إضافة المصروف",
            "pleaseSelectCategory": "الرجاء تحديد الفئة",
            "typeOrSelectCategory": "اكتب أو اختر فئة",
            "totalAfterDiscount": "الإجمالي بعد الخصم",
            "pleaseEnterAmount": "الرجاء إدخال المبلغ",
            "tuition": "الرسوم الدراسية",
            "registration": "التسجيل",
            "other": "أخرى",
            "rent": "الإيجار",
            "utilities": "المرافق",
            "salary": "الراتب",
            "supplies": "اللوازم",
            "cash": "نقدي",
            "onlinePayment": "الدفع عبر الإنترنت",
            "bank": "بنك",
            "currency": "عملة",
            "USD": "دولار أمريكي",
            "IQD": "دينار عراقي",
            "create": "إنشاء",
            "autoGenerated": "تلقائي",
            "paymentFrequency": "تكرار الدفع",
            "weekly": "أسبوعيًا",
            "daily": "يوميًا",
            "joinDate": "تاريخ الالتحاق",
            "employmentType": "نوع التوظيف",
            "department": "القسم",
            "staffNotFound": "الموظف غير موجود",
            "teachingCourses": "الدورات التدريسية",
            "notTeachingAnyCourses": "لا يدرس أي دورات",
            "cancel": "إلغاء",

            // Reports
            "financialReports": "التقارير المالية",
            "transactions": "المعاملات",
            "profit": "ربح",
            "loss": "خسارة",
            "profitMargin": "هامش الربح",
            "ofTotalIncome": "من إجمالي الدخل",
            "totalStudents": "إجمالي الطلاب",
            "totalStaff": "إجمالي الموظفين",
            "avgIncomePerTransaction": "متوسط الدخل لكل معاملة",
            "avgExpensePerTransaction": "متوسط المصروفات لكل معاملة",
            "thisMonth": "هذا الشهر",
            "incomeVsExpenses": "الدخل مقابل المصروفات",
            "financialDistribution": "التوزيع المالي",
            "monthlyTrend": "الاتجاه الشهري",
            "enrollmentTrend": "اتجاه التسجيل",
            "incomeBreakdown": "تفصيل الدخل",
            "expenseBreakdown": "تفصيل المصروفات",
            "incomeDetails": "تفاصيل الدخل",
            "expenseDetails": "تفاصيل المصروفات",
            "percentage": "النسبة المئوية",
            "total": "المجموع",
            "items": "عناصر",
            "pageTotal": "إجمالي الصفحة",
            "activeStudents": "الطلاب النشطين",
            "activeStaff": "الموظفين النشطين",
            "courseRevenue": "إيرادات الدورات",
            "salaryExpenses": "مصاريف الرواتب",
            "courseEnrollmentStats": "إحصائيات التسجيل في الدورات",
            "enrolledStudents": "الطلاب المسجلين",
            "enrolledStudentsList": "قائمة الطلاب المسجلين",
            "studentPaymentDetails": "تفاصيل دفع الطالب",
            "courseDetails": "تفاصيل الدورة",
            "paymentDetails": "تفاصيل الدفع",
            "paidAmount": "المبلغ المدفوع",
            "pendingAmount": "المبلغ المعلق",
            "invoice": "فاتورة",
            "incomeReceipt": "إيصال دخل",
            "expenseReceipt": "إيصال مصروف",
            "print": "طباعة",
            "preview": "معاينة",
            "close": "إغلاق",
            "languageInstituteManagementSystem": "نظام إدارة معهد اللغات",
            "generatedOn": "تم الإنشاء في",
            "authorizedSignature": "التوقيع المعتمد",
            "verificationCode": "رمز التحقق",
            "unpaidStudents": "الطلاب غير المدفوعين",
            "studentName": "اسم الطالب",
            "totalFee": "الرسوم الإجمالية",
            "remainingAmount": "المبلغ المتبقي",
            "paymentStatus": "حالة الدفع",
            "paymentInvoice": "فاتورة الدفع",
            "paid": "مدفوع",
            "partial": "مدفوع جزئيًا",
            "pending": "قيد الانتظار",
            "term1": "إذا لم يستطع الاستاذ الحضور في إحدى الدروس [لأي سبب كان]، يقوم بتعويض الدرس في وقت لاحق.",
            "term2": "المبلغ المدفوع غير قابل للاسترداد بأي حال من الأحوال",
            "term3": "إذا لم يحضر الطالب أكثر من 3 دروس، فلن يحصل على الشهادة بعد الانتهاء",

            // Invoices
            "createInvoice": "إنشاء فاتورة",
            "editInvoice": "تعديل الفاتورة",
            "invoiceNumber": "رقم الفاتورة",
            "invoiceDate": "تاريخ الفاتورة",
            "dueDate": "تاريخ الاستحقاق",
            "client": "العميل",
            "clientName": "اسم العميل",
            "clientEmail": "بريد العميل",
            "clientPhone": "هاتف العميل",
            "totalAmount": "المبلغ الإجمالي",
            "subtotal": "المجموع الفرعي",
            "tax": "الضريبة",
            "discount": "الخصم",
            "remainAmount": "المبلغ المتبقي",
            "payAmount": "مبلغ الدفع",
            "items": "العناصر",
            "quantity": "الكمية",
            "unitPrice": "سعر الوحدة",
            "addItem": "إضافة عنصر",
            "pleaseSelectType": "الرجاء تحديد النوع",
            "selectType": "اختر النوع",
            "selectStudent": "اختر الطالب",
            "selectStaff": "اختر الموظف",
            "selectCourse": "اختر الدورة",
            "enterClientName": "أدخل اسم العميل",
            "enterClientEmail": "أدخل بريد العميل",
            "enterClientPhone": "أدخل هاتف العميل",
            "enterNotes": "أدخل الملاحظات",
            "draft": "مسودة",
            "sent": "مرسلة",
            "cancelled": "ملغية",
            "payment": "دفع",
            "receipt": "إيصال",
            "receiptInvoice": "إيصال استلام",
            "recordPayment": "تسجيل الدفع",
            "discount": "خصم",
            "totalAfterDiscount": "الإجمالي بعد الخصم",
            "discountCannotExceedAmount": "لا يمكن أن يتجاوز الخصم المبلغ",
            "paymentAmount": "مبلغ الدفع",
            "paymentDate": "تاريخ الدفع",
            "selectPaymentMethod": "اختر طريقة الدفع",
            "card": "بطاقة",
            "online": "إنترنت",
            "notes": "ملاحظات",
            "billTo": "إلى",
            "update": "تحديث",
            "invoiceCreatedSuccessfully": "تم إنشاء الفاتورة بنجاح",
            "invoiceUpdatedSuccessfully": "تم تحديث الفاتورة بنجاح",
            "invoiceDeletedSuccessfully": "تم حذف الفاتورة بنجاح",
            "failedToCreateInvoice": "فشل في إنشاء الفاتورة",
            "failedToUpdateInvoice": "فشل في تحديث الفاتورة",
            "failedToDeleteInvoice": "فشل في حذف الفاتورة",
            "paymentRecordedSuccessfully": "تم تسجيل الدفع بنجاح",
            "failedToRecordPayment": "فشل في تسجيل الدفع",
            "paymentReceipt": "إيصال الدفع",
            "languageInstitute": "معهد تعليم اللغات",
            "studentInformation": "معلومات الطالب",
            "receiptDetails": "تفاصيل الإيصال",
            "receiptNumber": "رقم الإيصال",
            "totalCourseFee": "إجمالي رسوم الدورة",
            "amountPaid": "المبلغ المدفوع",
            "totalPaidToDate": "إجمالي المدفوع حتى الآن",
            "remainingBalance": "الرصيد المتبقي",
            "paymentStatus": "حالة الدفع",
            "thankYouForPayment": "شكراً لدفعك!",
            "computerGeneratedReceipt": "هذا إيصال إلكتروني ولا يتطلب توقيعاً",
            "printedOn": "طُبع في",
            "areYouSureDeleteInvoice": "هل أنت متأكد من حذف هذه الفاتورة؟ هذا الإجراء لا يمكن التراجع عنه.",

            // Messages
            "createdSuccessfully": "تم الإنشاء بنجاح",
            "updatedSuccessfully": "تم التحديث بنجاح",
            "deletedSuccessfully": "تم الحذف بنجاح",
            "confirmDelete": "هل أنت متأكد من حذف هذا العنصر؟",
            "actionCannotBeUndone": "لا يمكن التراجع عن هذا الإجراء",
            "removeCourseConfirm": "هل تريد إزالة هذا الكورس من الطالب؟ سيتم الاحتفاظ بسجلات الدفع.",
            "removeCourse": "إزالة الكورس",
            "removeCourseOnSave": "ستتم إزالة الكورس عند الحفظ.",
            "cannotRemoveLastCourse": "يجب أن يبقى للطالب كورس واحد على الأقل.",
            "yes": "نعم",
            "no": "لا",

            // Filters
            "filterByCourse": "تصفية حسب الدورة",
            "filterByGroup": "تصفية حسب المجموعة",
            "filterByStatus": "تصفية حسب الحالة",
            "filterByCategory": "تصفية حسب الفئة",
            "printSelected": "طباعة المحدد",
            "selectAll": "تحديد الكل",
            "deselectAll": "إلغاء تحديد الكل",
            "printCertificates": "طباعة الشهادات",
            "noCertificatesFound": "لم يتم العثور على شهادات",
            "filterByPosition": "تصفية حسب المنصب",
            "filterByInstructor": "تصفية حسب المدرس",
            "searchByNameOrEmail": "بحث بالاسم أو البريد",
            "searchByNameOrCode": "بحث بالاسم أو الرمز",

            // Table Headers
            "code": "الرمز",
            "actions": "الإجراءات",
            "receiptNo": "رقم الإيصال",
            "certificateNo": "رقم الشهادة",
            "student": "الطالب",
            "studentNotFound": "الطالب غير موجود",
            "coursesAttended": "الدورات الملتحقة",
            "back": "رجوع",
            "course": "الدورة",
            "courseNotFound": "الدورة غير موجودة",
            "totalIncome": "إجمالي الدخل",
            "enrolledStudents": "الطلاب المسجلين",
            "ended": "منتهية",
            "markAsEnded": "وضع علامة منتهية",
            "endThisCourse": "إنهاء هذه الدورة؟",
            "endCourseConfirmation": "سيتم وضع علامة منتهية على الدورة وإغلاق التسجيلات الإضافية.",
            "courseMarkedAsEnded": "تم وضع علامة منتهية على الدورة",
            "failedToEndCourse": "فشل في إنهاء الدورة",
            "confirm": "تأكيد",
            "issueDate": "تاريخ الإصدار",
            "paymentMethod": "طريقة الدفع",
            "role": "الدور",
            "academy": "الأكاديمية",

            // User Management
            "addUser": "إضافة مستخدم",
            "editUser": "تعديل المستخدم",
            "createUser": "إنشاء مستخدم",
            "updateUser": "تحديث المستخدم",
            "userCreatedSuccessfully": "تم إنشاء المستخدم بنجاح",
            "userUpdatedSuccessfully": "تم تحديث المستخدم بنجاح",
            "userDeletedSuccessfully": "تم حذف المستخدم بنجاح",
            "failedToCreateUser": "فشل في إنشاء المستخدم",
            "failedToUpdateUser": "فشل في تحديث المستخدم",
            "confirmDeleteUser": "هل أنت متأكد من حذف هذا المستخدم؟",
            "superAdmin": "مدير عام",
            "dataEntry": "إدخال البيانات",
            "selectRole": "اختر الدور",
            "selectAcademy": "اختر الأكاديمية",
            "pleaseEnterFirstName": "الرجاء إدخال الاسم الأول",
            "pleaseEnterLastName": "الرجاء إدخال اسم العائلة",
            "pleaseEnterEmail": "الرجاء إدخال البريد الإلكتروني",
            "pleaseEnterValidEmail": "الرجاء إدخال بريد إلكتروني صحيح",
            "pleaseSelectRole": "الرجاء اختيار الدور",
            "pleaseSelectAcademy": "الرجاء اختيار الأكاديمية",
            "pleaseEnterPassword": "الرجاء إدخال كلمة المرور",
            "password": "كلمة المرور",
            "passwordLeaveBlank": "كلمة المرور (اتركه فارغًا للإبقاء على الحالية)",
            "passwordMinLength": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
            "startDate": "تاريخ البدء",
            "endDate": "تاريخ الانتهاء",
            "autoGeneratedIfLeftBlank": "يتم إنشاؤه تلقائيًا إذا تُرك فارغًا",
            "pleaseEnterPhone": "الرجاء إدخال رقم الهاتف",
            "selectDate": "اختر التاريخ",
            "selectGender": "اختر الجنس",
            "selectCourse": "اختر الدورة",
            "selectStatus": "اختر الحالة",
            "assignToCourse": "تعيين للدورة",
            "assignCourses": "تعيين للدورات",
            "duplicateCourseInList": "لا يمكن تعيين نفس الدورة مرتين",
            "group": "المجموعة",
            "selectGroup": "اختر المجموعة",
            "courseGroups": "مجموعات الدورة",
            "courseGroupsTooltip": "حدد المجموعات لهذه الدورة (مثل Group A، Group B)",
            "graduated": "متخرج",
            "withdrawn": "منسحب",
            "createStudent": "إنشاء طالب",
            "updateStudent": "تحديث الطالب",
            "auditLogs": "سجلات التدقيق",
            "withdrawn": "منسحب",
            "createStudent": "اضافة الطالب",
            "updateStudent": "تحديث الطالب",
            "auditLogs": "سجلات التدقيق",
            "totalActions": "الإجمالي الإجراءات",
            "successfulActions": "الإجراءات الناجحة",
            "failedActions": "الإجراءات الفاشلة",
            "uniqueUsers": "المستخدمون الفريدون",
            "cleanOld": "تنظيف القديم",
            "auditLogDetails": "تفاصيل سجل التدقيق",
            "timestamp": "الطابع الزمني",
            "resource": "المورد",
            "ipAddress": "عنوان الآي بي",
            "userAgent": "وكيل المستخدم",
            "affectsCommission": "يؤثر على العمولة",
            "affectsCommissionTooltip": "تحديد ما إذا كان هذا الإجراء يؤثر على حساب العمولة للمستخدم",
            "errorMessage": "رسالة الخطأ",
            "details": "التفاصيل",
            "refresh": "تحديث",
            "selectResource": "اختر المورد",
            "selectStatus": "اختر الحالة",
            "deleteLogsOlderThan90Days": "حذف السجلات الأقدم من 90 يومًا",
            "selectAction": "اختر الإجراء",
            "cleanOld": "تنظيف القديم",
            "action": "الإجراء",
            "user": "المستخدم",

            // Certificate Templates
            "certificateTemplates": "قوالب الشهادات",
            "reactivateCourse": "إعادة تفعيل الدورة",
            "partilypaid": "مدفوع جزئيًا",
            // Social Messaging
            "Social Messaging": "الرسائل الاجتماعية",
            "Messages": "الرسائل",
            "Integrations": "التكاملات",
            "Platform": "المنصة",
            "Sender": "المرسل",
            "Message": "الرسالة",
            "Reply": "رد",
            "Convert": "تحويل",
            "to Student": "إلى طالب",
            "Reply to": "الرد على",
            "Original Message": "الرسالة الأصلية",
            "Your Reply": "ردك",
            "Please enter your reply": "الرجاء إدخال ردك",
            "Type your reply here...": "اكتب ردك هنا...",
            "Send Reply": "إرسال الرد",
            "Reply sent successfully": "تم إرسال الرد بنجاح",
            "Failed to send reply": "فشل إرسال الرد",
            "Convert to Student": "تحويل إلى طالب",
            "Successfully converted to student": "تم التحويل إلى طالب بنجاح",
            "Failed to convert to student": "فشل التحويل إلى طالب",
            "Assign to Course (Optional)": "تعيين إلى دورة (اختياري)",
            "Select a course": "اختر دورة",
            "Total Messages": "إجمالي الرسائل",
            "Pending": "قيد الانتظار",
            "Unread": "غير مقروء",
            "Converted": "محول",
            "Search by name, phone, or message": "البحث بالاسم أو الهاتف أو الرسالة",
            "Filter by platform": "تصفية حسب المنصة",
            "Filter by status": "تصفية حسب الحالة",
            "Replied": "تم الرد",
            "Archived": "مؤرشف",
            "Mark as Read": "وضع علامة كمقروء",
            "Reply": "رد",
            "Connect Your Social Platforms": "قم بتوصيل منصاتك الاجتماعية",
            "Receive and reply to messages from WhatsApp, Facebook, and Instagram directly in your academy dashboard. Convert leads to students with one click.": "استقبل والرد على الرسائل من واتساب وفيسبوك وإنستغرام مباشرة في لوحة تحكم الأكاديمية الخاصة بك. تحويل العملاء المحتملين إلى طلاب بنقرة واحدة.",
            "Save Configuration": "حفظ التكوين",
            "Integration saved successfully": "تم حفظ التكامل بنجاح",
            "Failed to save integration": "فشل حفظ التكامل",
            "Integration status updated": "تم تحديث حالة التكامل",
            "Failed to update status": "فشل تحديث الحالة",
            "Copied to clipboard": "تم النسخ",
            "createTemplate": "إنشاء قالب",
            "editTemplate": "تعديل القالب",
            "templateName": "اسم القالب",
            "pleaseEnterTemplateName": "الرجاء إدخال اسم القالب",
            "setAsDefault": "تعيين كافتراضي",
            "design": "التصميم",
            "layout": "التخطيط",
            "classic": "كلاسيكي",
            "modern": "حديث",
            "elegant": "أنيق",
            "minimal": "بسيط",
            "orientation": "الاتجاه",
            "landscape": "أفقي",
            "portrait": "عمودي",
            "borderWidth": "عرض الحدود",
            "backgroundColor": "لون الخلفية",
            "backgroundImage": "صورة الخلفية",
            "uploadBackground": "رفع الخلفية",
            "currentBackground": "الخلفية الحالية",
            "borderColor": "لون الحدود",
            "cornerDecorations": "زخارف الزوايا",
            "enableCornerDecorations": "تفعيل زخارف الزوايا",
            "decorationType": "نوع الزخرفة",
            "decorationColor": "لون الزخرفة",
            "decorationSize": "حجم الزخرفة",
            "floral": "زهري",
            "geometric": "هندسي",
            "ornamental": "زخرفي",
            "islamic": "إسلامي",
            "arabesque": "أرابيسك",
            "baroque": "باروكي",
            "celtic": "سلتي",
            "artDeco": "آرت ديكو",
            "vintage": "عتيق",
            "modernCurves": "منحنيات حديثة",
            "elegantSwirl": "دوامة أنيقة",
            "royal": "ملكي",

            // Social Integrations
            "Social Media Integrations": "پەیوەندیکردنی ڕاگەیاندنە کۆمەڵایەتیەکان",
            "Connect Your Social Platforms": "پلاتفۆرمە کۆمەڵایەتیەکانت بەستەوە",
            "Receive and reply to messages from Facebook and Instagram directly in your academy dashboard. Convert leads to students with one click.": "وەرگرتن و وەڵامدانەوەی نامەکان لە فەیسبووک و ئینستاگرام ڕاستەوخۆ لە داشبۆردی پەیمانگەکەت. گۆڕینی بەرژەوەندیداران بۆ قوتابی بە یەک کرتە.",
            "Facebook Messenger": "فەیسبووک مێسنجەر",
            "Instagram Direct": "ئینستاگرام دایرێکت",
            "Not Connected": "پەیوەست نەکراوە",
            "Active": "چالاک",
            "Inactive": "ناچالاک",
            "Deactivate": "ناچالاککردن",
            "Activate": "چالاککردن",
            "Easy Setup - One Click Connection": "ڕێکخستنی ئاسان - پەیوەندی بە یەک کرتە",
            "Click the button below to connect your Facebook page. You'll be redirected to Facebook to select a page and authorize access.": "کرتە لە دوگمەی خوارەوە بکە بۆ بەستنەوەی لاپەڕەی فەیسبووکەکەت. دەگوێزرێیتەوە بۆ فەیسبووک بۆ هەڵبژاردنی لاپەڕە و ڕێپێدان.",
            "Connect Facebook Messenger": "بەستنەوەی فەیسبووک مێسنجەر",
            "Reconnect Facebook": "بەستنەوەی دووبارەی فەیسبووک",
            "Click the button below to connect your Instagram Business account. You'll be redirected to Facebook to authorize access.": "کرتە لە دوگمەی خوارەوە بکە بۆ بەستنەوەی هەژماری بازرگانی ئینستاگرامەکەت. دەگوێزرێیتەوە بۆ فەیسبووک بۆ ڕێپێدان.",
            "Connect Instagram Direct": "بەستنەوەی ئینستاگرام دایرێکت",
            "Reconnect Instagram": "بەستنەوەی دووبارەی ئینستاگرام",
            "Manual Configuration (Advanced)": "ڕێکخستنی دەستی (پێشکەوتوو)",
            "Page ID": "ناسنامەی لاپەڕە",
            "Page Access Token": "تۆکێنی دەستگەیشتن بە لاپەڕە",
            "App ID": "ناسنامەی ئەپ",
            "Instagram Account ID": "ناسنامەی هەژماری ئینستاگرام",
            "Access Token": "تۆکێنی دەستگەیشتن",
            "Please enter Page ID": "تکایە ناسنامەی لاپەڕە بنووسە",
            "Please enter Page Access Token": "تکایە تۆکێنی دەستگەیشتن بە لاپەڕە بنووسە",
            "Please enter App ID": "تکایە ناسنامەی ئەپ بنووسە",
            "Please enter Account ID": "تکایە ناسنامەی هەژمار بنووسە",
            "Please enter Access Token": "تکایە تۆکێنی دەستگەیشتن بنووسە",
            "Enable Auto-Reply": "چالاککردنی وەڵامی خۆکار",
            "Enable Notifications": "چالاککردنی ئاگادارکردنەوەکان",
            "Remove Connection": "لابردنی پەیوەندی",
            "Are you sure you want to remove this integration? You will need to reconnect to use it again.": "دڵنیایت لە لابردنی ئەم پەیوەندیە؟ پێویستە دووبارە پەیوەندی بکەیتەوە بۆ بەکارهێنانی.",
            "Yes, Remove": "بەڵێ، لایبە",
            "Integration deleted successfully": "پەیوەندی بە سەرکەوتوویی سڕایەوە",
            "Failed to delete integration": "سڕینەوەی پەیوەندی سەرکەوتوو نەبوو",
            "removeBackground": "سڕینەوەی پاشبنەما",
            "backgroundRemoved": "پاشبنەما لە پاشەکەوتکردن سڕدەکرێتەوە",
            "removeLogo": "سڕینەوەی لۆگۆ",
            "logoRemoved": "لۆگۆ لە پاشەکەوتکردن سڕدەکرێتەوە",
            "removeSignature": "سڕینەوەی واژوو",
            "signatureRemoved": "واژوو لە پاشەکەوتکردن سڕدەکرێتەوە",
            "layoutSettings": "ڕێکخستنەکانی ڕێکخستن/بۆشایی",
            "contentPadding": "بۆشایی ناوەڕۆک",
            "bodyMaxWidth": "زۆرترین پانایی ناوەڕۆک",
            "footerMaxWidth": "زۆرترین پانایی ژێرەوە",
            "headerAlign": "ڕاستکردنەوەی سەرەوە",
            "titleAlign": "ڕاستکردنەوەی ناونیشان",
            "bodyAlign": "ڕاستکردنەوەی ناوەڕۆک",
            "footerAlign": "ڕاستکردنەوەی ژێرەوە",
            "headerSpacing": "بۆشایی سەرەوە",
            "titleSpacing": "بۆشایی ناونیشان",
            "bodySpacing": "بۆشایی ناوەڕۆک",
            "footerSpacing": "بۆشایی ژێرەوە",
            "logoAlign": "ڕاستکردنەوەی لۆگۆ",
            "logoMaxWidth": "زۆرترین پانایی لۆگۆ",
            "logoMaxHeight": "زۆرترین بەرزی لۆگۆ",
            "logoOffsetTop": "دورکردنەوەی سەرەوەی لۆگۆ",
            "font": "فۆنت",
            "size": "قەبارە",
            "bold": "قەڵەو",
            "italic": "لار",
            "underline": "ژێر هێڵ",
            "case": "شێوازی نووسین",
            "uppercase": "پیتە گەورەکان",
            "lowercase": "پیتە بچووکەکان",
            "capitalize": "سەرەتا گەورە",
            "signatureLabelPlaceholder": "ناونیشانی واژوو",
            "custom": "تایبەت",
            "label": "ناونیشان",
            "noLabel": "بێ ناونیشان",
            "addSignatureSlot": "زیادکردنی شوێنی واژوو ({{count}}/4)",
            "editLivePreview": "دەستکاریکردنی پیشاندانی ڕاستەوخۆ",
            "editing": "دەستکاریکردن",
            "previewApplied": "گۆڕانکاریەکانی پیشاندان جێبەجێکران",
            "previewCanceled": "گۆڕانکاریەکانی پیشاندان هەڵوەشاوە",
            "modernIslamic": "ئیسلامی مۆدێرن",
            "classicIslamic": "ئیسلامی کلاسیک",
            "modernOrnate": "ڕازاوەی مۆدێرن",
            "apply": "جێبەجێکردن",
            "left": "چەپ",
            "center": "ناوەڕاست",
            "right": "ڕاست",
            "signature": "واژوو",
            "directorSignature": "واژووی بەڕێوەبەر",

            // Online Accounting
            "onlineAccounting": {
                "title": "المحاسبة الإلكترونية",
                "students": "الطلاب الإلكترونيون",
                "expenses": "المصروفات الإلكترونية",
                "income": "الدخل الإلكتروني",
                "reports": "التقارير الإلكترونية",

                // Students
                "addStudent": "إضافة طالب إلكتروني",
                "editStudent": "تعديل طالب إلكتروني",
                "studentCreated": "تم إنشاء الطالب بنجاح",
                "studentUpdated": "تم تحديث الطالب بنجاح",
                "studentDeleted": "تم حذف الطالب بنجاح",
                "confirmDeleteStudent": "هل أنت متأكد من حذف هذا الطالب؟",
                "totalStudents": "إجمالي الطلاب",
                "activeStudents": "الطلاب النشطين",
                "searchStudent": "البحث عن الطلاب...",
                "filterByStatus": "تصفية حسب الحالة",
                "studentId": "رقم الطالب",
                "name": "الاسم",
                "firstName": "الاسم الأول",
                "lastName": "اسم العائلة",
                "email": "البريد الإلكتروني",
                "phone": "رقم الهاتف",
                "dateOfBirth": "تاريخ الميلاد",
                "gender": "الجنس",
                "male": "ذكر",
                "female": "أنثى",
                "other": "آخر",
                "course": "الدورة",
                "courseName": "اسم الدورة",
                "totalFees": "إجمالي الرسوم",
                "paidAmount": "المبلغ المدفوع",
                "remaining": "المتبقي",
                "paymentStatus": "حالة الدفع",
                "paid": "مدفوع",
                "partial": "جزئي",
                "unpaid": "غير مدفوع",
                "active": "نشط",
                "inactive": "غير نشط",
                "suspended": "معلق",
                "graduated": "متخرج",
                "notes": "ملاحظات",

                // Expenses
                "addExpense": "إضافة مصروف إلكتروني",
                "editExpense": "تعديل مصروف إلكتروني",
                "expenseCreated": "تم إنشاء المصروف بنجاح",
                "expenseUpdated": "تم تحديث المصروف بنجاح",
                "expenseDeleted": "تم حذف المصروف بنجاح",
                "confirmDeleteExpense": "هل أنت متأكد من حذف هذا المصروف؟",
                "totalExpenses": "إجمالي المصروفات",
                "searchExpense": "البحث عن المصروفات...",
                "filterByCategory": "تصفية حسب الفئة",
                "expenseNumber": "رقم المصروف",
                "date": "التاريخ",
                "category": "الفئة",
                "description": "الوصف",
                "vendor": "المورد",
                "vendorName": "اسم المورد",
                "vendorContact": "الاتصال بالمورد",
                "amount": "المبلغ",
                "paymentMethod": "طريقة الدفع",
                "hosting": "الاستضافة",
                "domain": "النطاق",
                "software": "البرمجيات",
                "marketing": "التسويق",
                "advertising": "الإعلان",
                "payment-gateway": "بوابة الدفع",
                "support-tools": "أدوات الدعم",
                "design": "التصميم",
                "development": "التطوير",
                "maintenance": "الصيانة",
                "other": "أخرى",
                "cash": "نقدي",
                "bank-transfer": "تحويل بنكي",
                "card": "بطاقة",
                "online": "إلكتروني",
                "paypal": "باي بال",
                "stripe": "سترايب",
                "pending": "قيد الانتظار",
                "cancelled": "ملغي",

                // Income
                "incomeNumber": "رقم الدخل",
                "studentName": "اسم الطالب",
                "totalPayments": "إجمالي المدفوعات",
                "searchIncome": "البحث عن الدخل...",
                "paymentType": "نوع الدفع",
                "enrollment": "التسجيل",
                "monthly": "شهري",
                "installment": "أقساط",
                "full-payment": "دفعة كاملة",
                "transactionId": "رقم المعاملة",
                "completed": "مكتمل",
                "failed": "فشل",
                "refunded": "مسترد",

                // Reports
                "totalIncomeUSD": "إجمالي الدخل (دولار)",
                "totalExpenseUSD": "إجمالي المصروفات (دولار)",
                "totalIncomeIQD": "إجمالي الدخل (دينار)",
                "totalExpenseIQD": "إجمالي المصروفات (دينار)",
                "profitUSD": "الربح (دولار)",
                "profitIQD": "الربح (دينار)",
                "studentPaymentStatus": "حالة دفع الطلاب",
                "monthlyIncome": "الدخل الشهري",
                "expensesByCategory": "المصروفات حسب الفئة",
                "totalUSD": "الإجمالي (دولار)",
                "totalIQD": "الإجمالي (دينار)",

                // Common
                "currency": "العملة",
                "status": "الحالة",
                "error": "حدث خطأ",
                "confirmDelete": "تأكيد الحذف",
                "view": "عرض",
                "addPayment": "إضافة دفعة",
                "paymentDetails": "تفاصيل الدفع",
                "studentDetails": "تفاصيل الطالب",
                "studentNotFound": "الطالب غير موجود",
                "paymentAdded": "تمت إضافة الدفعة بنجاح",
                "amountExceedsRemaining": "المبلغ يتجاوز الرصيد المتبقي",
                "editIncome": "تعديل الدخل الإلكتروني",
                "addIncome": "إضافة دخل إلكتروني",
                "student": "الطالب",
                "enterNotes": "أدخل ملاحظة",
            },
            "createdAt": "تاريخ التسجيل",
            "registrationDate": "تاريخ التسجيل",
            "lastPaymentDate": "آخر دفعة",
            "incomeSearchPlaceholder": "ابحث بالاسم أو رقم الإيصال أو الوصف",
            "incomeGrandTotal": "المجموع الكلي",
            "incomeTotalsByName": "المجاميع حسب الاسم",
            "incomePrintReport": "طباعة التقرير",
            "incomePrintSelected": "طباعة المحدد",
            "incomeRecordsCount": "عدد السجلات",
            "incomeReportTitle": "تقرير الإيرادات",
            "incomeAllCategories": "كل الفئات",
            "incomeSelectedCount": "المحدد",
            "customizeFormFields": "تخصيص حقول النموذج",
            "customizeFormFieldsHint": "الحقول المحددة تظهر في نموذج الطالب. ألغِ تحديد الحقول غير المطلوبة.",
            "emergencyPhone": "هاتف الطوارئ",
            "refund": "استرداد",
            "refundInvoice": "استرداد مبلغ الفاتورة",
            "refundReceipt": "إيصال استرداد",
            "refundAmount": "مبلغ الاسترداد",
            "refundedAmount": "المبلغ المسترد",
            "alreadyRefunded": "تم استرداده سابقاً",
            "maxRefundable": "الحد الأقصى للاسترداد",
            "refundMethod": "طريقة الاسترداد",
            "refundReason": "سبب الاسترداد",
            "enterRefundReason": "أدخل سبب الاسترداد (اختياري)",
            "confirmRefund": "تأكيد الاسترداد",
            "pleaseEnterRefundAmount": "الرجاء إدخال مبلغ الاسترداد",
            "refundExceedsPaid": "مبلغ الاسترداد يتجاوز المبلغ المدفوع",
            "refundRecordedSuccessfully": "تم تسجيل الاسترداد بنجاح",
            "refundFailed": "فشل تسجيل الاسترداد",
            "totalRefunded": "إجمالي المسترد",
            "refunded": "مسترد",
            "emergencyPhoneOwner": "صاحب هاتف الطوارئ",
            "selectEmergencyPhoneOwner": "اختر صاحب الهاتف",
            "father": "الأب",
            "mother": "الأم",
            "brother": "الأخ",
            "sister": "الأخت",
            "relative": "قريب",
            "school": "المدرسة",
            "enterSchool": "أدخل اسم المدرسة",
            "studyLanguage": "لغة الدراسة",
            "selectStudyLanguage": "اختر لغة الدراسة",
            "english": "الإنجليزية",
            "kurdish": "الكردية",
            "duplicateStudentExists": "يوجد طالب بالاسم \"{{name}}\" مسبقاً (الرقم: {{id}})",
            "failedToCreateStudent": "فشل في إنشاء الطالب",
            "currentCourse": "الكورس الحالي",
            "previousCourses": "الكورسات السابقة",
            "noActiveCourse": "لا يوجد كورس نشط",

            // Payment Notifications
            "paymentNotifications": "إشعارات الدفع",
            "activeNotifications": "الإشعارات النشطة",
            "unreadNotifications": "الإشعارات غير المقروءة",
            "overduePayments": "المدفوعات المتأخرة",
            "allNotifications": "جميع الإشعارات",
            "urgentPayments": "المدفوعات العاجلة",
            "markAllAsRead": "تحديد الكل كمقروء",
            "noNotifications": "لا توجد إشعارات",
            "noUrgentPayments": "لا توجد مدفوعات عاجلة",
            "noOverduePayments": "لا توجد مدفوعات متأخرة",
            "paymentDeadline": "موعد الدفع النهائي",
            "markAsRead": "تحديد كمقروء",
            "dismiss": "إغلاق",
            "overdue": "متأخر",
            "dueForPayment": "مستحق الدفع",
            "paymentCompleted": "تم الدفع",
            "daysOverdue": "أيام تأخير",
            "today": "اليوم",
            "daysLeft": "أيام متبقية",
            "failedToUpdateNotification": "فشل في تحديث الإشعار",
            "notificationDismissed": "تم إغلاق الإشعار",
            "failedToDismissNotification": "فشل في إغلاق الإشعار",
            "paymentNotificationCompleted": "تم تحديد الإشعار كمكتمل",
            "failedToCompleteNotification": "فشل في اكتمال الإشعار",
            "allNotificationsMarkedAsRead": "تم تحديد جميع الإشعارات كمقروءة",
            "failedToMarkAsRead": "فشل في التحديد كمقروء",
        },
    },
    en: {
        translation: {
            // Navigation
            "dashboard": "Dashboard",
            "academies": "Academies",
            "academic": "Academic",
            "students": "Students",
            "staff": "Staff",
            "courses": "Courses",
            "finance": "Finance",
            "income": "Income",
            "expenses": "Expenses",
            "recurringExpenses": "Recurring Expenses",
            "certificates": "Certificates",
            "invoices": "Invoices",
            "reports": "Reports",
            "users": "Users",
            "institute": "Institute",

            // Recurring Expenses
            "addRecurringExpense": "Add Recurring Expense",
            "editRecurringExpense": "Edit Recurring Expense",
            "recurringExpenseAdded": "Recurring expense added successfully",
            "recurringExpenseUpdated": "Recurring expense updated successfully",
            "recurringExpenseDeleted": "Recurring expense deleted successfully",
            "failedToAddRecurringExpense": "Failed to add recurring expense",
            "failedToUpdateRecurringExpense": "Failed to update recurring expense",
            "failedToDeleteRecurringExpense": "Failed to delete recurring expense",
            "confirmDeleteRecurringExpense": "Are you sure you want to delete this recurring expense?",
            "expenseName": "Expense Name",
            "pleaseEnterExpenseName": "Please enter expense name",
            "expenseNamePlaceholder": "e.g., Institute Rent, Electricity, Water",
            "expenseType": "Expense Type",
            "pleaseSelectExpenseType": "Please select expense type",
            "selectExpenseType": "Select expense type",
            "descriptionPlaceholder": "Additional details...",
            "frequency": "Frequency",
            "monthly": "Monthly",
            "quarterly": "Quarterly",
            "yearly": "Yearly",
            "dayOfMonth": "Day of Month",
            "startDate": "Start Date",
            "lastGenerated": "Last Generated",
            "generateMonthlyExpenses": "Generate Monthly Expenses",
            "monthlyExpensesGenerated": "Monthly expenses generated successfully",
            "failedToGenerateExpenses": "Failed to generate expenses",
            "generateExpensesDescription": "This will add all recurring expenses and active staff salaries for the selected month to the system",
            "month": "Month",
            "year": "Year",
            "generate": "Generate",
            "howItWorks": "How it works?",
            "recurringExpensesDescription": "Recurring expenses like rent and utilities are automatically generated every month. Active staff salaries are also added automatically.",

            // Month Names
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December",

            // Common
            "add": "Add",
            "edit": "Edit",
            "delete": "Delete",
            "save": "Save",
            "cancel": "Cancel",
            "login": "Login",
            "logout": "Logout",
            "paymanga": "Paymanga",
            "languageInstituteManagementSystem": "Language Institute Management System",
            "email": "Email",
            "password": "Password",
            "pleaseInputEmail": "Please input your email!",
            "pleaseInputPassword": "Please input your password!",
            "loginSuccessful": "Login successful!",
            "loginFailed": "Login failed",
            "search": "Search",
            "filter": "Filter",
            "actions": "Actions",
            "status": "Status",
            "active": "Active",
            "inactive": "Inactive",
            "loading": "Loading...",
            "profile": "Profile",
            "settings": "Settings",
            "personalInformation": "Personal Information",
            "notProvided": "Not Provided",
            "changePassword": "Change Password",
            "updatePassword": "Update Password",
            "currentPassword": "Current Password",
            "newPassword": "New Password",
            "confirmPassword": "Confirm Password",
            "passwordUpdatedSuccessfully": "Password updated successfully",
            "failedToUpdatePassword": "Failed to update password",
            "passwordsDoNotMatch": "Passwords do not match",
            "pleaseEnterCurrentPassword": "Please enter current password",
            "pleaseEnterNewPassword": "Please enter new password",
            "passwordMustBeAtLeast6Characters": "Password must be at least 6 characters",
            "pleaseConfirmPassword": "Please confirm password",
            "languageSettings": "Language Settings",
            "selectYourPreferredLanguage": "Select your preferred language",
            "notificationSettings": "Notification Settings",
            "enableNotifications": "Enable Notifications",
            "emailNotifications": "Email Notifications",
            "displaySettings": "Display Settings",
            "darkMode": "Dark Mode",
            "darkModeComingSoon": "Dark mode coming soon",
            "saveSettings": "Save Settings",
            "settingsSaved": "Settings saved successfully",
            "reset": "Reset",
            "automaticDatabaseBackup": "Automatic Database Backup",
            "backupDescription": "Database backup will be sent automatically every night to your email",
            "enableAutomaticBackup": "Enable Automatic Backup",
            "backupEmail": "Backup Email",
            "pleaseEnterValidEmail": "Please enter a valid email",
            "pleaseEnterBackupEmail": "Please enter backup email",
            "backupEmailHelp": "Backup will be sent to this email address",
            "backupTime": "Backup Time",
            "backupTimeHelp": "Select the time when backup will be sent daily",
            "saveBackupSettings": "Save Backup Settings",
            "sendTestBackup": "Send Test Backup",
            "backupSettingsSaved": "Backup settings saved successfully",
            "failedToSaveBackupSettings": "Failed to save backup settings",
            "backupEmailSent": "Backup email sent successfully",
            "failedToSendBackup": "Failed to send backup",
            "discountAmount": "Discount Amount",

            // Students
            "areYouSureDeleteInvoice": "Are you sure you want to delete this invoice?",
            "studentId": "Student ID",
            "firstName": "First Name",
            "lastName": "Last Name",
            "email": "Email",
            "phone": "Phone",
            "dateOfBirth": "Date of Birth",
            "gender": "Gender",
            "male": "Male",
            "female": "Female",
            "other": "Other",
            "degree": "Degree",
            "studyingType": "Studying Type",
            "selectStudyingType": "Select Studying Type",
            "inClass": "In Class",
            "liveOnline": "Live Online",
            "vip": "VIP",
            "recorded": "Recorded",
            "classStartHour": "Class Start Hour",
            "classEndHour": "Class End Hour",
            "howYouHeardUs": "How Did You Hear About Us?",
            "selectHowYouHeardUs": "Select",
            "instagram": "Instagram",
            "tiktok": "TikTok",
            "facebook": "Facebook",
            "friend": "Friend",
            "howYouHeardUsOther": "If Other, Please Specify",
            "specifyOther": "Specify",
            "pleaseSpecifyOther": "Please specify",
            "enrolledCourses": "Enrolled Courses",
            "addStudent": "Add Student",
            "addAcademy": "Add Academy",
            "editAcademy": "Edit Academy",
            "addNewAcademy": "Add New Academy",
            "courseFees": "Course Fees",
            "remainingAmount": "Remaining Amount",
            "subscription": "Subscription",
            "editStudent": "Edit Student",
            "studentDetails": "Student Details",
            "studentSignature": "Student Signature",
            "classTime": "Class Time",
            "address": "Address",

            // Staff
            "staffId": "Staff ID",
            "name": "Name",
            "position": "Position",
            "salary": "Salary",
            "teacher": "Teacher",
            "admin": "Admin",
            "reception": "Reception",
            "addStaff": "Add Staff",
            "editStaff": "Edit Staff",
            "commissionSettings": "Commission Settings",
            "enableCommission": "Enable Commission",
            "commissionType": "Commission Type",
            "percentage": "Percentage",
            "fixedAmount": "Fixed Amount",
            "commissionPercentage": "Commission Percentage",
            "fixedCommissionAmount": "Fixed Commission Amount",
            "appliesTo": "Applies To",
            "courseIncome": "Course Income",
            "allIncome": "All Income",
            "specificCourses": "Specific Courses",
            "selectCourses": "Select Courses",
            "commission": "Commission",
            "none": "None",
            "of": "of",
            "fixed": "Fixed",
            "perCourse": "per Course",

            // Courses
            "courseName": "Course Name",
            "courseCode": "Course Code",
            "instructor": "Instructor",
            "duration": "Duration",
            "fee": "Fee",
            "language": "Language",
            "level": "Level",
            "days": "Days",
            "weeks": "Weeks",
            "months": "Months",
            "unit": "Unit",
            "minCapacity": "Min Capacity",
            "maxCapacity": "Max Capacity",
            "selectInstructor": "Select Instructor",
            "addCourse": "Add Course",
            "editCourse": "Edit Course",
            "courseDetails": "Course Details",
            "subjects": "Subjects",
            "subject": "Subject",
            "subjectName": "Subject Name",
            "addSubject": "Add Subject",
            "editSubject": "Edit Subject",
            "selectSubject": "Select Subject",
            "courseCompletedSuccessfully": "Course completed successfully and certificates generated",
            "failedToCompleteCourse": "Failed to complete course",
            "complete": "Complete",
            "courseExpenses": "Course Expenses",
            "addCourseExpense": "Add Course Expense",
            "expenses": "Expenses",
            "expenseAddedSuccessfully": "Expense added successfully",
            "pleaseEnterDescription": "Please enter description",
            "expenseDescriptionPlaceholder": "e.g., Social media advertising, Course materials, etc.",
            "pleaseEnterAmount": "Please enter amount",
            "pleaseSelectCurrency": "Please select currency",
            "socialMedia": "Social Media",
            "advertising": "Advertising",
            "materials": "Materials",
            "additionalNotes": "Additional notes",
            "completeCourseConfirm": "Complete this course?",
            "completeCourseDescription": "This will mark the course as completed and generate certificates for all enrolled students",
            "yes": "Yes",
            "no": "No",

            // Finance
            "totalIncome": "Total Income",
            "totalExpenses": "Total Expenses",
            "totalDiscount": "Total Discount",
            "payAmount": "Pay Amount",
            "remainAmount": "Remain Amount",
            "netProfit": "Net Profit",
            "amount": "Amount",
            "date": "Date",
            "description": "Description",
            "category": "Category",
            "addIncome": "Add Income",
            "addExpense": "Add Expense",
            "incomeRecordAdded": "Income record added",
            "expenseRecordAdded": "Expense record added",
            "failedToAddIncome": "Failed to add income",
            "failedToAddExpense": "Failed to add expense",
            "pleaseSelectCategory": "Please select a category",
            "typeOrSelectCategory": "Type or select a category",
            "totalAfterDiscount": "Total After Discount",
            "pleaseEnterAmount": "Please enter amount",
            "tuition": "Tuition",
            "registration": "Registration",
            "other": "Other",
            "rent": "Rent",
            "utilities": "Utilities",
            "salary": "Salary",
            "supplies": "Supplies",
            "cash": "Cash",
            "onlinePayment": "Online Payment",
            "bank": "Bank",
            "currency": "Currency",
            "USD": "US Dollar",
            "IQD": "Iraqi Dinar",
            "create": "Create",
            "autoGenerated": "Auto-generated",
            "paymentFrequency": "Payment Frequency",
            "weekly": "Weekly",
            "daily": "Daily",
            "joinDate": "Join Date",
            "employmentType": "Employment Type",
            "department": "Department",
            "staffNotFound": "Staff not found",
            "teachingCourses": "Teaching Courses",
            "notTeachingAnyCourses": "Not teaching any courses",
            "cancel": "Cancel",

            // Reports
            "financialReports": "Financial Reports",
            "transactions": "Transactions",
            "profit": "Profit",
            "loss": "Loss",
            "profitMargin": "Profit Margin",
            "ofTotalIncome": "of Total Income",
            "totalStudents": "Total Students",
            "totalStaff": "Total Staff",
            "avgIncomePerTransaction": "Avg Income Per Transaction",
            "avgExpensePerTransaction": "Avg Expense Per Transaction",
            "thisMonth": "This Month",
            "incomeVsExpenses": "Income vs Expenses",
            "financialDistribution": "Financial Distribution",
            "monthlyTrend": "Monthly Trend",
            "enrollmentTrend": "Enrollment Trend",
            "incomeBreakdown": "Income Breakdown",
            "expenseBreakdown": "Expense Breakdown",
            "incomeDetails": "Income Details",
            "expenseDetails": "Expense Details",
            "percentage": "Percentage",
            "total": "Total",
            "items": "Items",
            "pageTotal": "Page Total",
            "activeStudents": "Active Students",
            "activeStaff": "Active Staff",
            "courseRevenue": "Course Revenue",
            "salaryExpenses": "Salary Expenses",
            "courseEnrollmentStats": "Course Enrollment Statistics",
            "courseReport": "Course Report",
            "generalReports": "General Reports",
            "selectCourse": "Select Course",
            "selectCourseToViewReport": "Select a course to view report",
            "courseInformation": "Course Information",
            "totalCommission": "Total Commission",
            "profitCalculation": "Profit Calculation",
            "staffCommissions": "Staff Commissions",
            "commissionValue": "Commission Value",
            "commissionAmount": "Commission Amount",
            "staffReport": "Staff Report",
            "selectStaff": "Select Staff",
            "selectStaffToViewReport": "Select a staff member to view report",
            "staffInformation": "Staff Information",
            "totalSalary": "Total Salary",
            "monthlySalary": "Monthly Salary",
            "dateRange": "Date Range",
            "paymentHistory": "Payment History",
            "salaryRecords": "Salary Records",
            "commissionBreakdown": "Commission Breakdown",
            "coursesTeaching": "Courses Teaching",
            "studentsEnrolled": "Students Enrolled",
            "financialOverview": "Financial Overview",
            "studentPaymentStatus": "Student Payment Status",
            "revenueDistribution": "Revenue Distribution",
            "fullyPaid": "Fully Paid",
            "partiallyPaid": "Partially Paid",
            "unpaid": "Unpaid",
            "incomeBreakdown": "Income Breakdown",
            "coursePerformance": "Course Performance",
            "salaryTrend": "Salary Trend",
            "studentCount": "Student Count",
            "income": "Income",
            "source": "Source",
            "baseAmount": "Base Amount",
            "paidDate": "Paid Date",
            "enrollmentDate": "Enrollment Date",
            "activeCourses": "Active Courses",
            "completedCourses": "Completed Courses",
            "statistics": "Statistics",
            "enrolledStudents": "Enrolled Students",
            "enrolledStudentsList": "Enrolled Students List",
            "studentPaymentDetails": "Student Payment Details",
            "courseDetails": "Course Details",
            "paymentDetails": "Payment Details",
            "paidAmount": "Paid Amount",
            "pendingAmount": "Pending Amount",
            "invoice": "Invoice",
            "incomeReceipt": "Income Receipt",
            "expenseReceipt": "Expense Receipt",
            "print": "Print",
            "preview": "Preview",
            "close": "Close",
            "languageInstituteManagementSystem": "Language Institute Management System",
            "generatedOn": "Generated On",
            "authorizedSignature": "Authorized Signature",
            "verificationCode": "Verification Code",
            "unpaidStudents": "Unpaid Students",
            "studentName": "Student Name",
            "totalFee": "Total Fee",
            "remainingAmount": "Remaining Amount",
            "paymentStatus": "Payment Status",
            "paymentInvoice": "Payment Invoice",
            "paid": "Paid",
            "partial": "Partial",
            "reactivateCourse": "Reactivate Course",
            "pending": "Pending",
            "term1": "If the teacher couldn’t attend for any reasons, the lesson will be compensated for the students",
            "term2": "The amount paid is non-refundable under any circumstances",
            "term3": "If the student does not attend more than 3 classes, they will not receive a certificate after completion",
            "termsAndConditions": "Terms and Conditions",
            "followUs": "Follow Us",
            "advisoryTelephone": "Advisory Telephone",
            // Invoices
            "createInvoice": "Create Invoice",
            "editInvoice": "Edit Invoice",
            "invoiceNumber": "Invoice Number",
            "invoiceDate": "Invoice Date",
            "dueDate": "Due Date",
            "client": "Client",
            "clientName": "Client Name",
            "clientEmail": "Client Email",
            "clientPhone": "Client Phone",
            "totalAmount": "Total Amount",
            "subtotal": "Subtotal",
            "tax": "Tax",
            "discount": "Discount",
            "items": "Items",
            "quantity": "Quantity",
            "unitPrice": "Unit Price",
            "addItem": "Add Item",
            "pleaseSelectType": "Please select type",
            "selectType": "Select type",
            "selectStudent": "Select student",
            "selectStaff": "Select staff",
            "selectCourse": "Select course",
            "enterClientName": "Enter client name",
            "enterClientEmail": "Enter client email",
            "enterClientPhone": "Enter client phone",
            "enterNotes": "Enter notes",
            "draft": "Draft",
            "sent": "Sent",
            "cancelled": "Cancelled",
            "payment": "Payment",
            "receipt": "Receipt",
            "receiptInvoice": "Receipt Invoice",
            "recordPayment": "Record Payment",
            "discount": "Discount",
            "totalAfterDiscount": "Total After Discount",
            "discountCannotExceedAmount": "Discount cannot exceed amount",
            "paymentAmount": "Payment Amount",
            "paymentDate": "Payment Date",
            "selectPaymentMethod": "Select payment method",
            "card": "Card",
            "online": "Online",
            "notes": "Notes",
            "billTo": "Bill To",
            "update": "Update",
            "invoiceCreatedSuccessfully": "Invoice created successfully",
            "invoiceUpdatedSuccessfully": "Invoice updated successfully",
            "invoiceDeletedSuccessfully": "Invoice deleted successfully",
            "failedToCreateInvoice": "Failed to create invoice",
            "failedToUpdateInvoice": "Failed to update invoice",
            "failedToDeleteInvoice": "Failed to delete invoice",
            "paymentRecordedSuccessfully": "Payment recorded successfully",
            "failedToRecordPayment": "Failed to record payment",
            "paymentReceipt": "Payment Receipt",
            "languageInstitute": "Language Institute Management System",
            "studentInformation": "Student Information",
            "receiptDetails": "Receipt Details",
            "receiptNumber": "Receipt #",
            "totalCourseFee": "Total Course Fee",
            "amountPaid": "Amount Paid",
            "totalPaidToDate": "Total Paid to Date",
            "remainingBalance": "Remaining Balance",
            "paymentStatus": "Payment Status",
            "thankYouForPayment": "Thank you for your payment!",
            "computerGeneratedReceipt": "This is a computer-generated receipt and does not require a signature",
            "printedOn": "Printed on",

            // Messages
            "createdSuccessfully": "Created successfully",
            "updatedSuccessfully": "Updated successfully",
            "deletedSuccessfully": "Deleted successfully",
            "confirmDelete": "Are you sure you want to delete this item?",
            "actionCannotBeUndone": "This action cannot be undone",
            "removeCourseConfirm": "Remove this course from the student? Payment records will be kept.",
            "removeCourse": "Remove Course",
            "removeCourseOnSave": "The course will be removed when you save.",
            "cannotRemoveLastCourse": "The student must keep at least one course.",
            "invoiceDetails": "Invoice Details",
            "noDataFound": "No data found",
            "InvoiceNo": "Invoice No.",
            // Filters
            "filterByCourse": "Filter by Course",
            "filterByGroup": "Filter by Group",
            "filterByStatus": "Filter by Status",
            "filterByCategory": "Filter by Category",
            "printSelected": "Print Selected",
            "selectAll": "Select All",
            "deselectAll": "Deselect All",
            "printCertificates": "Print Certificates",
            "noCertificatesFound": "No certificates found",
            "filterByPosition": "Filter by Position",
            "filterByInstructor": "Filter by Instructor",
            "searchByNameOrEmail": "Search by name or email",
            "searchByNameOrCode": "Search by name or code",

            // Table Headers
            "code": "Code",
            "actions": "Actions",
            "receiptNo": "Receipt No",
            "certificateNo": "Certificate No",
            "student": "Student",
            "studentNotFound": "Student not found",
            "coursesAttended": "Courses Attended",
            "back": "Back",
            "course": "Course",
            "courseNotFound": "Course not found",
            "totalIncome": "Total Income",
            "enrolledStudents": "Enrolled Students",
            "ended": "Ended",
            "markAsEnded": "Mark as Ended",
            "endThisCourse": "End this course?",
            "endCourseConfirmation": "This will mark the course as ended and lock further enrollments.",
            "courseMarkedAsEnded": "Course marked as ended",
            "failedToEndCourse": "Failed to end course",
            "confirm": "Confirm",
            "issueDate": "Issue Date",
            "paymentMethod": "Payment Method",
            "role": "Role",
            "academy": "Academy",

            // User Management
            "addUser": "Add User",
            "editUser": "Edit User",
            "createUser": "Create User",
            "updateUser": "Update User",
            "userCreatedSuccessfully": "User created successfully",
            "userUpdatedSuccessfully": "User updated successfully",
            "userDeletedSuccessfully": "User deleted successfully",
            "failedToCreateUser": "Failed to create user",
            "failedToUpdateUser": "Failed to update user",
            "confirmDeleteUser": "Are you sure you want to delete this user?",
            "superAdmin": "Super Admin",
            "dataEntry": "Data Entry",
            "selectRole": "Select role",
            "selectAcademy": "Select academy",
            "pleaseEnterFirstName": "Please enter first name",
            "pleaseEnterLastName": "Please enter last name",
            "pleaseEnterEmail": "Please enter email",
            "pleaseEnterValidEmail": "Please enter a valid email",
            "pleaseSelectRole": "Please select role",
            "pleaseSelectAcademy": "Please select academy",
            "pleaseEnterPassword": "Please enter password",
            "password": "Password",
            "passwordLeaveBlank": "Password (leave blank to keep current)",
            "passwordMinLength": "Password must be at least 6 characters",
            "startDate": "Start Date",
            "endDate": "End Date",
            "autoGeneratedIfLeftBlank": "Auto-generated if left blank",
            "pleaseEnterPhone": "Please enter phone number",
            "selectDate": "Select date",
            "selectGender": "Select gender",
            "selectCourse": "Select course",
            "selectStatus": "Select status",
            "assignToCourse": "Assign to Course",
            "assignCourses": "Assign to Courses",
            "duplicateCourseInList": "Cannot assign the same course twice",
            "group": "Group",
            "selectGroup": "Select Group",
            "courseGroups": "Course Groups",
            "courseGroupsTooltip": "Define groups for this course (e.g. Group A, Group B)",
            "graduated": "Graduated",
            "withdrawn": "Withdrawn",
            "createStudent": "Create Student",
            "updateStudent": "Update Student",
            "auditLogs": "Audit Logs",
            "createStudent": "Create Student",
            "updateStudent": "Update Student",
            "auditLogs": "Audit Logs",
            "totalActions": "Total Actions",
            "successfulActions": "Successful Actions",
            "failedActions": "Failed Actions",
            "uniqueUsers": "Unique Users",
            "cleanOld": "Clean Old",
            "auditLogDetails": "Audit Log Details",
            "timestamp": "Timestamp",
            "resource": "Resource",
            "ipAddress": "IP Address",
            "userAgent": "User Agent",
            "affectsCommission": "Affects Commission",
            "affectsCommissionTooltip": "If enabled, this action will impact staff commissions based on the institute's commission settings.",
            "errorMessage": "Error Message",
            "details": "Details",
            "refresh": "Refresh",
            "selectResource": "Select Resource",
            "selectStatus": "Select Status",
            "deleteLogsOlderThan90Days": "Delete Logs Older Than 90 Days",
            "cleanOld": "Clean Old",
            "action": "Action",
            "user": "User",
            "selectAction": "Select Action",

            // Certificate Templates
            "certificateTemplates": "Certificate Templates",

            // Social Messaging
            "Social Messaging": "Social Messaging",
            "Messages": "Messages",
            "Integrations": "Integrations",
            "Platform": "Platform",
            "Sender": "Sender",
            "Message": "Message",
            "Reply": "Reply",
            "Convert": "Convert",
            "to Student": "to Student",
            "Reply to": "Reply to",
            "Original Message": "Original Message",
            "Your Reply": "Your Reply",
            "Please enter your reply": "Please enter your reply",
            "Type your reply here...": "Type your reply here...",
            "Send Reply": "Send Reply",
            "Reply sent successfully": "Reply sent successfully",
            "Failed to send reply": "Failed to send reply",
            "Convert to Student": "Convert to Student",
            "Successfully converted to student": "Successfully converted to student",
            "Failed to convert to student": "Failed to convert to student",
            "Assign to Course (Optional)": "Assign to Course (Optional)",
            "Select a course": "Select a course",
            "Total Messages": "Total Messages",
            "Pending": "Pending",
            "Unread": "Unread",
            "Converted": "Converted",
            "Search by name, phone, or message": "Search by name, phone, or message",
            "Filter by platform": "Filter by platform",
            "Filter by status": "Filter by status",
            "Replied": "Replied",
            "Archived": "Archived",
            "Mark as Read": "Mark as Read",
            "Reply": "Reply",
            "Connect Your Social Platforms": "Connect Your Social Platforms",
            "Receive and reply to messages from WhatsApp, Facebook, and Instagram directly in your academy dashboard. Convert leads to students with one click.": "Receive and reply to messages from Facebook and Instagram directly in your academy dashboard. Convert leads to students with one click.",
            "Save Configuration": "Save Configuration",
            "Integration saved successfully": "Integration saved successfully",
            "Failed to save integration": "Failed to save integration",
            "Integration status updated": "Integration status updated",
            "Failed to update status": "Failed to update status",
            "Copied to clipboard": "Copied to clipboard",

            // Social Integrations
            "Social Media Integrations": "Social Media Integrations",
            "Facebook Messenger": "Facebook Messenger",
            "Instagram Direct": "Instagram Direct",
            "Not Connected": "Not Connected",
            "Deactivate": "Deactivate",
            "Activate": "Activate",
            "Easy Setup - One Click Connection": "Easy Setup - One Click Connection",
            "Click the button below to connect your Facebook page. You'll be redirected to Facebook to select a page and authorize access.": "Click the button below to connect your Facebook page. You'll be redirected to Facebook to select a page and authorize access.",
            "Connect Facebook Messenger": "Connect Facebook Messenger",
            "Reconnect Facebook": "Reconnect Facebook",
            "Click the button below to connect your Instagram Business account. You'll be redirected to Facebook to authorize access.": "Click the button below to connect your Instagram Business account. You'll be redirected to Facebook to authorize access.",
            "Connect Instagram Direct": "Connect Instagram Direct",
            "Reconnect Instagram": "Reconnect Instagram",
            "Manual Configuration (Advanced)": "Manual Configuration (Advanced)",
            "Page ID": "Page ID",
            "Page Access Token": "Page Access Token",
            "App ID": "App ID",
            "Instagram Account ID": "Instagram Account ID",
            "Access Token": "Access Token",
            "Please enter Page ID": "Please enter Page ID",
            "Please enter Page Access Token": "Please enter Page Access Token",
            "Please enter App ID": "Please enter App ID",
            "Please enter Account ID": "Please enter Account ID",
            "Please enter Access Token": "Please enter Access Token",
            "Enable Auto-Reply": "Enable Auto-Reply",
            "Enable Notifications": "Enable Notifications",
            "Remove Connection": "Remove Connection",
            "Are you sure you want to remove this integration? You will need to reconnect to use it again.": "Are you sure you want to remove this integration? You will need to reconnect to use it again.",
            "Yes, Remove": "Yes, Remove",
            "Integration deleted successfully": "Integration deleted successfully",
            "Failed to delete integration": "Failed to delete integration",

            "createTemplate": "Create Template",
            "editTemplate": "Edit Template",
            "templateName": "Template Name",
            "pleaseEnterTemplateName": "Please enter template name",
            "setAsDefault": "Set as Default",
            "design": "Design",
            "layout": "Layout",
            "classic": "Classic",
            "modern": "Modern",
            "elegant": "Elegant",
            "minimal": "Minimal",
            "orientation": "Orientation",
            "landscape": "Landscape",
            "portrait": "Portrait",
            "borderWidth": "Border Width",
            "backgroundColor": "Background Color",
            "backgroundImage": "Background Image",
            "uploadBackground": "Upload Background",
            "currentBackground": "Current Background",
            "borderColor": "Border Color",
            "cornerDecorations": "Corner Decorations",
            "enableCornerDecorations": "Enable Corner Decorations",
            "decorationType": "Decoration Type",
            "decorationColor": "Decoration Color",
            "decorationSize": "Decoration Size",
            "floral": "Floral",
            "geometric": "Geometric",
            "ornamental": "Ornamental",
            "islamic": "Islamic",
            "arabesque": "Arabesque",
            "baroque": "Baroque",
            "celtic": "Celtic",
            "artDeco": "Art Deco",
            "vintage": "Vintage",
            "modernCurves": "Modern Curves",
            "elegantSwirl": "Elegant Swirl",
            "royal": "Royal",
            "removeBackground": "Remove Background",
            "backgroundRemoved": "Background will be removed on save",
            "removeLogo": "Remove Logo",
            "logoRemoved": "Logo will be removed on save",
            "removeSignature": "Remove Signature",
            "signatureRemoved": "Signature will be removed on save",
            "layoutSettings": "Layout & Spacing",
            "contentPadding": "Content Padding",
            "bodyMaxWidth": "Body Max Width",
            "footerMaxWidth": "Footer Max Width",
            "headerAlign": "Header Align",
            "titleAlign": "Title Align",
            "bodyAlign": "Body Align",
            "footerAlign": "Footer Align",
            "headerSpacing": "Header Space",
            "titleSpacing": "Title Space",
            "bodySpacing": "Body Space",
            "footerSpacing": "Footer Space",
            "logoAlign": "Logo Align",
            "logoMaxWidth": "Logo Max Width",
            "logoMaxHeight": "Logo Max Height",
            "logoOffsetTop": "Logo Top Offset",
            "font": "Font",
            "size": "Size",
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline",
            "case": "Case",
            "uppercase": "UPPERCASE",
            "lowercase": "lowercase",
            "capitalize": "Capitalize",
            "signatureLabelPlaceholder": "Signature Label",
            "custom": "Custom",
            "label": "Label",
            "noLabel": "No Label",
            "addSignatureSlot": "Add Signature Slot ({{count}}/4)",
            "editLivePreview": "Edit Live Preview",
            "editing": "Editing",
            "previewApplied": "Preview changes applied",
            "previewCanceled": "Preview changes canceled",
            "modernIslamic": "Modern Islamic",
            "classicIslamic": "Classic Islamic",
            "modernOrnate": "Modern Ornate",
            "apply": "Apply",
            "left": "Left",
            "center": "Center",
            "right": "Right",
            "signature": "Signature",
            "directorSignature": "Director Signature",

            // Online Accounting
            "onlineAccounting": {
                "title": "Online Accounting",
                "students": "Online Students",
                "expenses": "Online Expenses",
                "income": "Online Income",
                "reports": "Online Reports",

                // Students
                "addStudent": "Add Online Student",
                "editStudent": "Edit Online Student",
                "studentCreated": "Student created successfully",
                "studentUpdated": "Student updated successfully",
                "studentDeleted": "Student deleted successfully",
                "confirmDeleteStudent": "Are you sure you want to delete this student?",
                "totalStudents": "Total Students",
                "activeStudents": "Active Students",
                "searchStudent": "Search for students...",
                "filterByStatus": "Filter by Status",
                "studentId": "Student ID",
                "name": "Name",
                "firstName": "First Name",
                "lastName": "Last Name",
                "email": "Email",
                "phone": "Phone Number",
                "dateOfBirth": "Date of Birth",
                "gender": "Gender",
                "male": "Male",
                "female": "Female",
                "other": "Other",
                "course": "Course",
                "courseName": "Course Name",
                "totalFees": "Total Fees",
                "paidAmount": "Paid Amount",
                "remaining": "Remaining",
                "paymentStatus": "Payment Status",
                "paid": "Paid",
                "partial": "Partial",
                "unpaid": "Unpaid",
                "active": "Active",
                "inactive": "Inactive",
                "suspended": "Suspended",
                "graduated": "Graduated",
                "notes": "Notes",

                // Expenses
                "addExpense": "Add Online Expense",
                "editExpense": "Edit Online Expense",
                "expenseCreated": "Expense created successfully",
                "expenseUpdated": "Expense updated successfully",
                "expenseDeleted": "Expense deleted successfully",
                "confirmDeleteExpense": "Are you sure you want to delete this expense?",
                "totalExpenses": "Total Expenses",
                "searchExpense": "Search for expenses...",
                "filterByCategory": "Filter by Category",
                "expenseNumber": "Expense Number",
                "date": "Date",
                "category": "Category",
                "description": "Description",
                "vendor": "Vendor",
                "vendorName": "Vendor Name",
                "vendorContact": "Vendor Contact",
                "amount": "Amount",
                "paymentMethod": "Payment Method",
                "hosting": "Hosting",
                "domain": "Domain",
                "software": "Software",
                "marketing": "Marketing",
                "advertising": "Advertising",
                "payment-gateway": "Payment Gateway",
                "support-tools": "Support Tools",
                "design": "Design",
                "development": "Development",
                "maintenance": "Maintenance",
                "other": "Other",
                "cash": "Cash",
                "bank-transfer": "Bank Transfer",
                "card": "Card",
                "online": "Online",
                "paypal": "PayPal",
                "stripe": "Stripe",
                "pending": "Pending",
                "cancelled": "Cancelled",

                // Income
                "incomeNumber": "Income Number",
                "studentName": "Student Name",
                "totalPayments": "Total Payments",
                "searchIncome": "Search for income...",
                "paymentType": "Payment Type",
                "enrollment": "Enrollment",
                "monthly": "Monthly",
                "installment": "Installment",
                "full-payment": "Full Payment",
                "transactionId": "Transaction ID",
                "completed": "Completed",
                "failed": "Failed",
                "refunded": "Refunded",

                // Reports
                "totalIncomeUSD": "Total Income (USD)",
                "totalExpenseUSD": "Total Expense (USD)",
                "totalIncomeIQD": "Total Income (IQD)",
                "totalExpenseIQD": "Total Expense (IQD)",
                "profitUSD": "Profit (USD)",
                "profitIQD": "Profit (IQD)",
                "studentPaymentStatus": "Student Payment Status",
                "monthlyIncome": "Monthly Income",
                "expensesByCategory": "Expenses by Category",
                "totalUSD": "Total (USD)",
                "totalIQD": "Total (IQD)",

                // Common
                "currency": "Currency",
                "status": "Status",
                "error": "An error occurred",
                "confirmDelete": "Confirm Delete",
                "view": "View",
                "addPayment": "Add Payment",
                "paymentDetails": "Payment Details",
                "studentDetails": "Student Details",
                "studentNotFound": "Student not found",
                "paymentAdded": "Payment added successfully",
                "amountExceedsRemaining": "Amount exceeds remaining balance",
                "editIncome": "Edit Online Income",
                "addIncome": "Add Online Income",
                "student": "Student",
                "enterNotes": "Enter note",
            },
            "createdAt": "Registration Date",
            "registrationDate": "Registration Date",
            "lastPaymentDate": "Last Payment",
            "incomeSearchPlaceholder": "Search name, receipt no, description",
            "incomeGrandTotal": "Grand Total",
            "incomeTotalsByName": "Totals by name",
            "incomePrintReport": "Print report",
            "incomePrintSelected": "Print selected",
            "incomeRecordsCount": "Records",
            "incomeReportTitle": "Income Report",
            "incomeAllCategories": "All categories",
            "incomeSelectedCount": "Selected",
            "customizeFormFields": "Customize form fields",
            "customizeFormFieldsHint": "Checked fields are shown in the student form. Uncheck the ones you don't need.",
            "emergencyPhone": "Emergency Phone",
            "refund": "Refund",
            "refundInvoice": "Refund / Cashback",
            "refundReceipt": "Refund Receipt",
            "refundAmount": "Refund Amount",
            "refundedAmount": "Refunded Amount",
            "alreadyRefunded": "Already Refunded",
            "maxRefundable": "Max Refundable",
            "refundMethod": "Refund Method",
            "refundReason": "Refund Reason",
            "enterRefundReason": "Enter refund reason (optional)",
            "confirmRefund": "Confirm Refund",
            "pleaseEnterRefundAmount": "Please enter refund amount",
            "refundExceedsPaid": "Refund amount exceeds the paid amount",
            "refundRecordedSuccessfully": "Refund recorded successfully",
            "refundFailed": "Failed to record refund",
            "totalRefunded": "Total Refunded",
            "refunded": "Refunded",
            "emergencyPhoneOwner": "Emergency Phone Owner",
            "selectEmergencyPhoneOwner": "Select phone owner",
            "father": "Father",
            "mother": "Mother",
            "brother": "Brother",
            "sister": "Sister",
            "relative": "Relative",
            "school": "School",
            "enterSchool": "Enter school name",
            "studyLanguage": "Study Language",
            "selectStudyLanguage": "Select study language",
            "english": "English",
            "kurdish": "Kurdish",
            "duplicateStudentExists": "A student with the name \"{{name}}\" already exists (ID: {{id}})",
            "failedToCreateStudent": "Failed to create student",
            "currentCourse": "Current Course",
            "previousCourses": "Previous Courses",
            "noActiveCourse": "No active course",

            // Payment Notifications
            "paymentNotifications": "Payment Notifications",
            "activeNotifications": "Active Notifications",
            "unreadNotifications": "Unread Notifications",
            "overduePayments": "Overdue Payments",
            "allNotifications": "All Notifications",
            "urgentPayments": "Urgent Payments",
            "markAllAsRead": "Mark All as Read",
            "noNotifications": "No notifications",
            "noUrgentPayments": "No urgent payments",
            "noOverduePayments": "No overdue payments",
            "paymentDeadline": "Payment Deadline",
            "markAsRead": "Mark as read",
            "dismiss": "Dismiss",
            "overdue": "Overdue",
            "dueForPayment": "Due for Payment",
            "paymentCompleted": "Payment Completed",
            "daysOverdue": "days overdue",
            "today": "Today",
            "daysLeft": "days left",
            "failedToUpdateNotification": "Failed to update notification",
            "notificationDismissed": "Notification dismissed",
            "failedToDismissNotification": "Failed to dismiss notification",
            "paymentNotificationCompleted": "Notification marked as completed",
            "failedToCompleteNotification": "Failed to complete notification",
            "allNotificationsMarkedAsRead": "All notifications marked as read",
            "failedToMarkAsRead": "Failed to mark as read",
        },
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'ku', // Default language is Kurdish
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });

export default i18n;
